// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/stars.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/icons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27var%28--gray-500%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/zb-icons.eot?38568115", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/zb-icons.woff2?38568115", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/zb-icons.woff?38568115", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/zb-icons.ttf?38568115", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/zb-icons.svg?38568115", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/Zeebit-Sans.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/Zeebit-Sans-Caps.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/Zeebit-Sans-Test.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Satoshi:wght@300;400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anton:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "#zb-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.10 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--gray-200); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: var(--gray-400); /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: var(--gray-400); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: var(--gray-500);
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  color: var(--gray-500);
  opacity: 1;
}

input::placeholder,textarea::placeholder {
  color: var(--gray-500);
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: none;
  background-image: initial;
  background-position: 0 0;
  background-position: initial;
  background-repeat: repeat;
  background-repeat: initial;
  background-size: auto auto;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}

[type='checkbox'],[type='radio'] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: var(--gray-500);
  border-width: 1px;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active)  {

  [type='checkbox']:checked {
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active)  {

  [type='radio']:checked {
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active)  {

  [type='checkbox']:indeterminate {
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

* {
  scrollbar-color: initial;
  scrollbar-width: initial;
}
  html {
    font-family: var(--default-app-font-family), sans-serif;
    color: var(--general-text-color);
    background: var(--general-bg);
    font-weight: 700;
    font-size: 16px;
    line-height: 1.1rem;
  }

  /* Hides up/down arrows in number inputs */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}
.pointer-events-none {
  pointer-events: none !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
.static {
  position: static !important;
}
.fixed {
  position: fixed !important;
}
.absolute {
  position: absolute !important;
}
.relative {
  position: relative !important;
}
.sticky {
  position: sticky !important;
}
.inset-0 {
  top: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
}
.inset-1 {
  top: 4px !important;
  right: 4px !important;
  bottom: 4px !important;
  left: 4px !important;
}
.-left-1 {
  left: -4px !important;
}
.-left-8 {
  left: -32px !important;
}
.-left-\\[5\\%\\] {
  left: -5% !important;
}
.-left-\\[50\\%\\] {
  left: -50% !important;
}
.-top-0\\.5 {
  top: -2px !important;
}
.-top-8 {
  top: -32px !important;
}
.-top-\\[15px\\] {
  top: -15px !important;
}
.-top-\\[5\\%\\] {
  top: -5% !important;
}
.-top-\\[52px\\] {
  top: -52px !important;
}
.-top-\\[80px\\] {
  top: -80px !important;
}
.-top-\\[84px\\] {
  top: -84px !important;
}
.bottom-0 {
  bottom: 0px !important;
}
.bottom-0\\.5 {
  bottom: 2px !important;
}
.bottom-1 {
  bottom: 4px !important;
}
.bottom-10 {
  bottom: 40px !important;
}
.bottom-12 {
  bottom: 48px !important;
}
.bottom-16 {
  bottom: 64px !important;
}
.bottom-2 {
  bottom: 8px !important;
}
.bottom-2\\.5 {
  bottom: 0.625rem !important;
}
.bottom-3 {
  bottom: 12px !important;
}
.bottom-4 {
  bottom: 16px !important;
}
.bottom-5 {
  bottom: 20px !important;
}
.bottom-6 {
  bottom: 24px !important;
}
.bottom-8 {
  bottom: 32px !important;
}
.bottom-\\[110px\\] {
  bottom: 110px !important;
}
.left-0 {
  left: 0px !important;
}
.left-0\\.5 {
  left: 2px !important;
}
.left-1 {
  left: 4px !important;
}
.left-1\\/2 {
  left: 50% !important;
}
.left-10 {
  left: 40px !important;
}
.left-2 {
  left: 8px !important;
}
.left-3 {
  left: 12px !important;
}
.left-6 {
  left: 24px !important;
}
.left-8 {
  left: 32px !important;
}
.left-\\[42px\\] {
  left: 42px !important;
}
.left-\\[50\\%\\] {
  left: 50% !important;
}
.left-\\[75px\\] {
  left: 75px !important;
}
.left-\\[84px\\] {
  left: 84px !important;
}
.left-\\[calc\\(\\(100\\%_-_280px\\)_\\/_2_\\+_280px\\)\\] {
  left: calc((100% - 280px) / 2 + 280px) !important;
}
.left-\\[calc\\(50\\%\\+30px\\)\\] {
  left: calc(50% + 30px) !important;
}
.right-0 {
  right: 0px !important;
}
.right-1 {
  right: 4px !important;
}
.right-2 {
  right: 8px !important;
}
.right-4 {
  right: 16px !important;
}
.right-6 {
  right: 24px !important;
}
.right-8 {
  right: 32px !important;
}
.right-\\[1\\%\\] {
  right: 1% !important;
}
.right-auto {
  right: auto !important;
}
.top-0 {
  top: 0px !important;
}
.top-0\\.5 {
  top: 2px !important;
}
.top-1 {
  top: 4px !important;
}
.top-1\\/2 {
  top: 50% !important;
}
.top-16 {
  top: 64px !important;
}
.top-2 {
  top: 8px !important;
}
.top-3 {
  top: 12px !important;
}
.top-5 {
  top: 20px !important;
}
.top-\\[18\\%\\] {
  top: 18% !important;
}
.top-\\[20px\\] {
  top: 20px !important;
}
.top-\\[40px\\] {
  top: 40px !important;
}
.top-\\[50\\%\\] {
  top: 50% !important;
}
.top-\\[50px\\] {
  top: 50px !important;
}
.top-\\[80px\\] {
  top: 80px !important;
}
.top-\\[calc\\(50\\%-20px\\)\\] {
  top: calc(50% - 20px) !important;
}
.top-\\[calc\\(50\\%-32px\\)\\] {
  top: calc(50% - 32px) !important;
}
.top-\\[calc\\(50\\%-52px\\)\\] {
  top: calc(50% - 52px) !important;
}
.top-\\[calc\\(50\\%-80px\\)\\] {
  top: calc(50% - 80px) !important;
}
.-z-10 {
  z-index: -10 !important;
}
.z-0 {
  z-index: 0 !important;
}
.z-10 {
  z-index: 10 !important;
}
.z-20 {
  z-index: 20 !important;
}
.z-30 {
  z-index: 30 !important;
}
.z-40 {
  z-index: 40 !important;
}
.z-50 {
  z-index: 50 !important;
}
.z-\\[1\\] {
  z-index: 1 !important;
}
.z-\\[2\\] {
  z-index: 2 !important;
}
.z-\\[49\\] {
  z-index: 49 !important;
}
.-order-2 {
  order: -2 !important;
}
.order-1 {
  order: 1 !important;
}
.col-span-1 {
  grid-column: span 1 / span 1 !important;
}
.col-span-2 {
  grid-column: span 2 / span 2 !important;
}
.col-span-3 {
  grid-column: span 3 / span 3 !important;
}
.col-span-4 {
  grid-column: span 4 / span 4 !important;
}
.col-span-5 {
  grid-column: span 5 / span 5 !important;
}
.col-span-6 {
  grid-column: span 6 / span 6 !important;
}
.col-span-7 {
  grid-column: span 7 / span 7 !important;
}
.col-start-2 {
  grid-column-start: 2 !important;
}
.row-start-1 {
  grid-row-start: 1 !important;
}
.row-start-2 {
  grid-row-start: 2 !important;
}
.m-1 {
  margin: 4px !important;
}
.-mx-2 {
  margin-left: -8px !important;
  margin-right: -8px !important;
}
.-mx-6 {
  margin-left: -24px !important;
  margin-right: -24px !important;
}
.-my-1 {
  margin-top: -4px !important;
  margin-bottom: -4px !important;
}
.-my-5 {
  margin-top: -20px !important;
  margin-bottom: -20px !important;
}
.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}
.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.my-\\[3\\%\\] {
  margin-top: 3% !important;
  margin-bottom: 3% !important;
}
.my-\\[30px\\] {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.-mb-1 {
  margin-bottom: -4px !important;
}
.-mb-12 {
  margin-bottom: -48px !important;
}
.-mb-2 {
  margin-bottom: -8px !important;
}
.-mb-\\[10px\\] {
  margin-bottom: -10px !important;
}
.-ml-\\[10px\\] {
  margin-left: -10px !important;
}
.-ml-\\[1px\\] {
  margin-left: -1px !important;
}
.-mr-1 {
  margin-right: -4px !important;
}
.-mr-3 {
  margin-right: -12px !important;
}
.-mr-\\[25\\%\\] {
  margin-right: -25% !important;
}
.-mr-\\[55px\\] {
  margin-right: -55px !important;
}
.-mt-0\\.5 {
  margin-top: -2px !important;
}
.-mt-1 {
  margin-top: -4px !important;
}
.-mt-1\\.5 {
  margin-top: -6px !important;
}
.-mt-2 {
  margin-top: -8px !important;
}
.-mt-20 {
  margin-top: -80px !important;
}
.-mt-3 {
  margin-top: -12px !important;
}
.-mt-4 {
  margin-top: -16px !important;
}
.-mt-5 {
  margin-top: -20px !important;
}
.-mt-6 {
  margin-top: -24px !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.mb-0\\.5 {
  margin-bottom: 2px !important;
}
.mb-1 {
  margin-bottom: 4px !important;
}
.mb-12 {
  margin-bottom: 48px !important;
}
.mb-2 {
  margin-bottom: 8px !important;
}
.mb-3 {
  margin-bottom: 12px !important;
}
.mb-4 {
  margin-bottom: 16px !important;
}
.mb-5 {
  margin-bottom: 20px !important;
}
.mb-6 {
  margin-bottom: 24px !important;
}
.mb-7 {
  margin-bottom: 28px !important;
}
.mb-\\[24px\\] {
  margin-bottom: 24px !important;
}
.mb-\\[2px\\] {
  margin-bottom: 2px !important;
}
.mb-\\[3px\\] {
  margin-bottom: 3px !important;
}
.me-1 {
  margin-right: 4px !important;
}
.me-\\[4px\\] {
  margin-right: 4px !important;
}
.ml-0 {
  margin-left: 0px !important;
}
.ml-1 {
  margin-left: 4px !important;
}
.ml-2 {
  margin-left: 8px !important;
}
.ml-3 {
  margin-left: 12px !important;
}
.ml-5 {
  margin-left: 20px !important;
}
.ml-6 {
  margin-left: 24px !important;
}
.ml-\\[5px\\] {
  margin-left: 5px !important;
}
.ml-auto {
  margin-left: auto !important;
}
.ml-left-bar-width {
  margin-left: var(--side-bar-width) !important;
}
.ml-right-bar-width {
  margin-left: var(--side-bar-width) !important;
}
.ml-right-bar-width-wide {
  margin-left: var(--side-bar-width-wide) !important;
}
.mr-0\\.5 {
  margin-right: 2px !important;
}
.mr-1 {
  margin-right: 4px !important;
}
.mr-1\\.5 {
  margin-right: 6px !important;
}
.mr-10 {
  margin-right: 40px !important;
}
.mr-2 {
  margin-right: 8px !important;
}
.mr-3 {
  margin-right: 12px !important;
}
.mr-5 {
  margin-right: 20px !important;
}
.mr-\\[4px\\] {
  margin-right: 4px !important;
}
.mr-\\[5px\\] {
  margin-right: 5px !important;
}
.ms-1 {
  margin-left: 4px !important;
}
.mt-0 {
  margin-top: 0px !important;
}
.mt-0\\.5 {
  margin-top: 2px !important;
}
.mt-1 {
  margin-top: 4px !important;
}
.mt-1\\.5 {
  margin-top: 6px !important;
}
.mt-16 {
  margin-top: 64px !important;
}
.mt-2 {
  margin-top: 8px !important;
}
.mt-2\\.5 {
  margin-top: 0.625rem !important;
}
.mt-3 {
  margin-top: 12px !important;
}
.mt-4 {
  margin-top: 16px !important;
}
.mt-5 {
  margin-top: 20px !important;
}
.mt-5\\.5 {
  margin-top: 22px !important;
}
.mt-6 {
  margin-top: 24px !important;
}
.mt-6\\.5 {
  margin-top: 26px !important;
}
.mt-7 {
  margin-top: 28px !important;
}
.mt-8 {
  margin-top: 32px !important;
}
.mt-\\[117px\\] {
  margin-top: 117px !important;
}
.mt-\\[160px\\] {
  margin-top: 160px !important;
}
.mt-\\[30px\\] {
  margin-top: 30px !important;
}
.mt-\\[3px\\] {
  margin-top: 3px !important;
}
.mt-\\[48px\\] {
  margin-top: 48px !important;
}
.line-clamp-1 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}
.line-clamp-4 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 4 !important;
}
.block {
  display: block !important;
}
.inline-block {
  display: inline-block !important;
}
.inline {
  display: inline !important;
}
.flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex !important;
}
.table {
  display: table !important;
}
.table-cell {
  display: table-cell !important;
}
.table-row {
  display: table-row !important;
}
.grid {
  display: grid !important;
}
.contents {
  display: contents !important;
}
.hidden {
  display: none !important;
}
.aspect-\\[2\\/1\\] {
  aspect-ratio: 2/1 !important;
}
.aspect-\\[368\\/480\\] {
  aspect-ratio: 368/480 !important;
}
.aspect-\\[4\\/5\\.5\\] {
  aspect-ratio: 4/5.5 !important;
}
.aspect-auto {
  aspect-ratio: auto !important;
}
.aspect-square {
  aspect-ratio: 1 / 1 !important;
}
.aspect-video {
  aspect-ratio: 16 / 9 !important;
}
.h-0 {
  height: 0px !important;
}
.h-1 {
  height: 4px !important;
}
.h-1\\.5 {
  height: 6px !important;
}
.h-10 {
  height: 40px !important;
}
.h-12 {
  height: 48px !important;
}
.h-2 {
  height: 8px !important;
}
.h-24 {
  height: 96px !important;
}
.h-3 {
  height: 12px !important;
}
.h-3\\.5 {
  height: 14px !important;
}
.h-4 {
  height: 16px !important;
}
.h-4\\.5 {
  height: 18px !important;
}
.h-5 {
  height: 20px !important;
}
.h-5\\.5 {
  height: 22px !important;
}
.h-6 {
  height: 24px !important;
}
.h-6\\.5 {
  height: 26px !important;
}
.h-7 {
  height: 28px !important;
}
.h-8 {
  height: 32px !important;
}
.h-\\[100\\%\\] {
  height: 100% !important;
}
.h-\\[100px\\] {
  height: 100px !important;
}
.h-\\[110\\%\\] {
  height: 110% !important;
}
.h-\\[110px\\] {
  height: 110px !important;
}
.h-\\[120px\\] {
  height: 120px !important;
}
.h-\\[12px\\] {
  height: 12px !important;
}
.h-\\[130px\\] {
  height: 130px !important;
}
.h-\\[132px\\] {
  height: 132px !important;
}
.h-\\[140px\\] {
  height: 140px !important;
}
.h-\\[14px\\] {
  height: 14px !important;
}
.h-\\[15px\\] {
  height: 15px !important;
}
.h-\\[160px\\] {
  height: 160px !important;
}
.h-\\[16px\\] {
  height: 16px !important;
}
.h-\\[174px\\] {
  height: 174px !important;
}
.h-\\[180px\\] {
  height: 180px !important;
}
.h-\\[184px\\] {
  height: 184px !important;
}
.h-\\[18px\\] {
  height: 18px !important;
}
.h-\\[1px\\] {
  height: 1px !important;
}
.h-\\[20\\%\\] {
  height: 20% !important;
}
.h-\\[200\\%\\] {
  height: 200% !important;
}
.h-\\[200px\\] {
  height: 200px !important;
}
.h-\\[20px\\] {
  height: 20px !important;
}
.h-\\[218px\\] {
  height: 218px !important;
}
.h-\\[220px\\] {
  height: 220px !important;
}
.h-\\[22px\\] {
  height: 22px !important;
}
.h-\\[23px\\] {
  height: 23px !important;
}
.h-\\[24px\\] {
  height: 24px !important;
}
.h-\\[25px\\] {
  height: 25px !important;
}
.h-\\[26px\\] {
  height: 26px !important;
}
.h-\\[27px\\] {
  height: 27px !important;
}
.h-\\[28px\\] {
  height: 28px !important;
}
.h-\\[300px\\] {
  height: 300px !important;
}
.h-\\[30px\\] {
  height: 30px !important;
}
.h-\\[30vh\\] {
  height: 30vh !important;
}
.h-\\[320px\\] {
  height: 320px !important;
}
.h-\\[32px\\] {
  height: 32px !important;
}
.h-\\[34px\\] {
  height: 34px !important;
}
.h-\\[35px\\] {
  height: 35px !important;
}
.h-\\[36px\\] {
  height: 36px !important;
}
.h-\\[38px\\] {
  height: 38px !important;
}
.h-\\[40px\\] {
  height: 40px !important;
}
.h-\\[40vh\\] {
  height: 40vh !important;
}
.h-\\[42px\\] {
  height: 42px !important;
}
.h-\\[44px\\] {
  height: 44px !important;
}
.h-\\[45px\\] {
  height: 45px !important;
}
.h-\\[48px\\] {
  height: 48px !important;
}
.h-\\[50\\%\\] {
  height: 50% !important;
}
.h-\\[50px\\] {
  height: 50px !important;
}
.h-\\[54px\\] {
  height: 54px !important;
}
.h-\\[56px\\] {
  height: 56px !important;
}
.h-\\[60px\\] {
  height: 60px !important;
}
.h-\\[60vh\\] {
  height: 60vh !important;
}
.h-\\[62px\\] {
  height: 62px !important;
}
.h-\\[64px\\] {
  height: 64px !important;
}
.h-\\[65\\%\\] {
  height: 65% !important;
}
.h-\\[6px\\] {
  height: 6px !important;
}
.h-\\[70px\\] {
  height: 70px !important;
}
.h-\\[75px\\] {
  height: 75px !important;
}
.h-\\[80\\%\\] {
  height: 80% !important;
}
.h-\\[86px\\] {
  height: 86px !important;
}
.h-\\[8px\\] {
  height: 8px !important;
}
.h-\\[calc\\(100\\%\\+4px\\)\\] {
  height: calc(100% + 4px) !important;
}
.h-\\[calc\\(100\\%-50px\\)\\] {
  height: calc(100% - 50px) !important;
}
.h-\\[calc\\(100\\%-90px\\)\\] {
  height: calc(100% - 90px) !important;
}
.h-\\[calc\\(100\\%_\\+_24px\\)\\] {
  height: calc(100% + 24px) !important;
}
.h-\\[var\\(--game-frame-tool-bar-height\\)\\] {
  height: var(--game-frame-tool-bar-height) !important;
}
.h-auto {
  height: auto !important;
}
.h-full {
  height: 100% !important;
}
.h-screen-minus-both-bars {
  height: calc(100vh - var(--top-bar-height) - var(--top-bar-height)) !important;
}
.h-top-banner-height {
  height: var(--top-banner-height) !important;
}
.h-top-bar-height {
  height: var(--top-bar-height) !important;
}
.max-h-40 {
  max-height: 10rem !important;
}
.max-h-56 {
  max-height: 14rem !important;
}
.max-h-\\[134px\\] {
  max-height: 134px !important;
}
.max-h-\\[200px\\] {
  max-height: 200px !important;
}
.max-h-\\[300px\\] {
  max-height: 300px !important;
}
.max-h-\\[50vh\\] {
  max-height: 50vh !important;
}
.max-h-\\[542px\\] {
  max-height: 542px !important;
}
.max-h-\\[700px\\] {
  max-height: 700px !important;
}
.max-h-\\[70vh\\] {
  max-height: 70vh !important;
}
.max-h-\\[var\\(--modal-header-height\\)\\] {
  max-height: var(--modal-header-height) !important;
}
.max-h-full {
  max-height: 100% !important;
}
.max-h-screen-minus-bar {
  max-height: calc(100vh - var(--top-bar-height)) !important;
}
.min-h-0 {
  min-height: 0px !important;
}
.min-h-60 {
  min-height: 240px !important;
}
.min-h-\\[200px\\] {
  min-height: 200px !important;
}
.min-h-\\[250px\\] {
  min-height: 250px !important;
}
.min-h-\\[32px\\] {
  min-height: 32px !important;
}
.min-h-\\[460px\\] {
  min-height: 460px !important;
}
.min-h-\\[500px\\] {
  min-height: 500px !important;
}
.min-h-\\[50vh\\] {
  min-height: 50vh !important;
}
.min-h-\\[700px\\] {
  min-height: 700px !important;
}
.min-h-\\[90vh\\] {
  min-height: 90vh !important;
}
.min-h-full {
  min-height: 100% !important;
}
.w-0 {
  width: 0px !important;
}
.w-1\\/12 {
  width: 8.333333% !important;
}
.w-1\\/2 {
  width: 50% !important;
}
.w-1\\/3 {
  width: 33.333333% !important;
}
.w-1\\/4 {
  width: 25% !important;
}
.w-1\\/5 {
  width: 20% !important;
}
.w-10 {
  width: 40px !important;
}
.w-11\\/12 {
  width: 91.666667% !important;
}
.w-12 {
  width: 48px !important;
}
.w-14 {
  width: 56px !important;
}
.w-16 {
  width: 64px !important;
}
.w-2 {
  width: 8px !important;
}
.w-20 {
  width: 80px !important;
}
.w-24 {
  width: 96px !important;
}
.w-3 {
  width: 12px !important;
}
.w-3\\.5 {
  width: 14px !important;
}
.w-3\\/4 {
  width: 75% !important;
}
.w-36 {
  width: 9rem !important;
}
.w-4 {
  width: 16px !important;
}
.w-4\\.5 {
  width: 18px !important;
}
.w-5 {
  width: 20px !important;
}
.w-5\\.5 {
  width: 22px !important;
}
.w-52 {
  width: 13rem !important;
}
.w-6 {
  width: 24px !important;
}
.w-6\\.5 {
  width: 26px !important;
}
.w-8 {
  width: 32px !important;
}
.w-\\[100\\%\\] {
  width: 100% !important;
}
.w-\\[100px\\] {
  width: 100px !important;
}
.w-\\[110\\%\\] {
  width: 110% !important;
}
.w-\\[110px\\] {
  width: 110px !important;
}
.w-\\[120px\\] {
  width: 120px !important;
}
.w-\\[125\\%\\] {
  width: 125% !important;
}
.w-\\[12px\\] {
  width: 12px !important;
}
.w-\\[12rem\\] {
  width: 12rem !important;
}
.w-\\[130px\\] {
  width: 130px !important;
}
.w-\\[14px\\] {
  width: 14px !important;
}
.w-\\[150px\\] {
  width: 150px !important;
}
.w-\\[160px\\] {
  width: 160px !important;
}
.w-\\[165px\\] {
  width: 165px !important;
}
.w-\\[16px\\] {
  width: 16px !important;
}
.w-\\[17\\%\\] {
  width: 17% !important;
}
.w-\\[18px\\] {
  width: 18px !important;
}
.w-\\[2\\%\\] {
  width: 2% !important;
}
.w-\\[20\\%\\] {
  width: 20% !important;
}
.w-\\[20px\\] {
  width: 20px !important;
}
.w-\\[20rem\\] {
  width: 20rem !important;
}
.w-\\[220px\\] {
  width: 220px !important;
}
.w-\\[221px\\] {
  width: 221px !important;
}
.w-\\[22px\\] {
  width: 22px !important;
}
.w-\\[23\\%\\] {
  width: 23% !important;
}
.w-\\[24px\\] {
  width: 24px !important;
}
.w-\\[25\\%\\] {
  width: 25% !important;
}
.w-\\[260px\\] {
  width: 260px !important;
}
.w-\\[26px\\] {
  width: 26px !important;
}
.w-\\[27px\\] {
  width: 27px !important;
}
.w-\\[280px\\] {
  width: 280px !important;
}
.w-\\[28px\\] {
  width: 28px !important;
}
.w-\\[300px\\] {
  width: 300px !important;
}
.w-\\[30px\\] {
  width: 30px !important;
}
.w-\\[320px\\] {
  width: 320px !important;
}
.w-\\[324px\\] {
  width: 324px !important;
}
.w-\\[32px\\] {
  width: 32px !important;
}
.w-\\[340px\\] {
  width: 340px !important;
}
.w-\\[342px\\] {
  width: 342px !important;
}
.w-\\[34px\\] {
  width: 34px !important;
}
.w-\\[35\\%\\] {
  width: 35% !important;
}
.w-\\[35px\\] {
  width: 35px !important;
}
.w-\\[36px\\] {
  width: 36px !important;
}
.w-\\[38px\\] {
  width: 38px !important;
}
.w-\\[3px\\] {
  width: 3px !important;
}
.w-\\[40\\%\\] {
  width: 40% !important;
}
.w-\\[40px\\] {
  width: 40px !important;
}
.w-\\[45px\\] {
  width: 45px !important;
}
.w-\\[50\\%\\] {
  width: 50% !important;
}
.w-\\[500px\\] {
  width: 500px !important;
}
.w-\\[50px\\] {
  width: 50px !important;
}
.w-\\[560px\\] {
  width: 560px !important;
}
.w-\\[60\\%\\] {
  width: 60% !important;
}
.w-\\[600px\\] {
  width: 600px !important;
}
.w-\\[60px\\] {
  width: 60px !important;
}
.w-\\[64px\\] {
  width: 64px !important;
}
.w-\\[65\\%\\] {
  width: 65% !important;
}
.w-\\[70px\\] {
  width: 70px !important;
}
.w-\\[80\\%\\] {
  width: 80% !important;
}
.w-\\[80vw\\] {
  width: 80vw !important;
}
.w-\\[84px\\] {
  width: 84px !important;
}
.w-\\[85\\%\\] {
  width: 85% !important;
}
.w-\\[85vw\\] {
  width: 85vw !important;
}
.w-\\[86px\\] {
  width: 86px !important;
}
.w-\\[8px\\] {
  width: 8px !important;
}
.w-\\[90vw\\] {
  width: 90vw !important;
}
.w-\\[94px\\] {
  width: 94px !important;
}
.w-\\[calc\\(100\\%\\+8px\\)\\] {
  width: calc(100% + 8px) !important;
}
.w-\\[calc\\(100\\%_\\+_12px\\)\\] {
  width: calc(100% + 12px) !important;
}
.w-\\[calc\\(100\\%_-_120px\\)\\] {
  width: calc(100% - 120px) !important;
}
.w-\\[calc\\(40\\%\\)\\] {
  width: calc(40%) !important;
}
.w-auto {
  width: auto !important;
}
.w-full {
  width: 100% !important;
}
.w-left-bar-collapsed-width {
  width: var(--side-bar-collapsed-width) !important;
}
.w-left-bar-width {
  width: var(--side-bar-width) !important;
}
.w-right-bar-width {
  width: var(--side-bar-width) !important;
}
.w-screen {
  width: 100vw !important;
}
.min-w-24 {
  min-width: 96px !important;
}
.min-w-\\[140px\\] {
  min-width: 140px !important;
}
.min-w-\\[300px\\] {
  min-width: 300px !important;
}
.min-w-\\[60px\\] {
  min-width: 60px !important;
}
.min-w-\\[700px\\] {
  min-width: 700px !important;
}
.min-w-full {
  min-width: 100% !important;
}
.max-w-7xl {
  max-width: 80rem !important;
}
.max-w-\\[184px\\] {
  max-width: 184px !important;
}
.max-w-\\[250px\\] {
  max-width: 250px !important;
}
.max-w-\\[360px\\] {
  max-width: 360px !important;
}
.max-w-\\[480px\\] {
  max-width: 480px !important;
}
.max-w-\\[50\\%\\] {
  max-width: 50% !important;
}
.max-w-\\[50px\\] {
  max-width: 50px !important;
}
.max-w-\\[692px\\] {
  max-width: 692px !important;
}
.max-w-\\[700px\\] {
  max-width: 700px !important;
}
.max-w-\\[750px\\] {
  max-width: 750px !important;
}
.max-w-\\[80\\%\\] {
  max-width: 80% !important;
}
.max-w-\\[calc\\(100\\%_\\+_112px\\)\\] {
  max-width: calc(100% + 112px) !important;
}
.max-w-full {
  max-width: 100% !important;
}
.max-w-sm {
  max-width: 24rem !important;
}
.flex-1 {
  flex: 1 1 0% !important;
}
.flex-none {
  flex: none !important;
}
.flex-shrink {
  flex-shrink: 1 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.shrink {
  flex-shrink: 1 !important;
}
.shrink-0 {
  flex-shrink: 0 !important;
}
.flex-grow {
  flex-grow: 1 !important;
}
.flex-grow-0 {
  flex-grow: 0 !important;
}
.grow {
  flex-grow: 1 !important;
}
.grow-0 {
  flex-grow: 0 !important;
}
.basis-1 {
  flex-basis: 4px !important;
}
.basis-full {
  flex-basis: 100% !important;
}
.origin-top-right {
  transform-origin: top right !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50% !important;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-10 {
  --tw-translate-x: -40px !important;
  transform: translate(-40px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50% !important;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-\\[50\\%\\] {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-1 {
  --tw-translate-x: 4px !important;
  transform: translate(4px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-10 {
  --tw-translate-x: 40px !important;
  transform: translate(40px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-16 {
  --tw-translate-x: 64px !important;
  transform: translate(64px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-6 {
  --tw-translate-x: 24px !important;
  transform: translate(24px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-7 {
  --tw-translate-x: 28px !important;
  transform: translate(28px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-8 {
  --tw-translate-x: 32px !important;
  transform: translate(32px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-9 {
  --tw-translate-x: 36px !important;
  transform: translate(36px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-1\\/2 {
  --tw-translate-y: 50% !important;
  transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-4 {
  --tw-translate-y: 16px !important;
  transform: translate(var(--tw-translate-x), 16px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-8 {
  --tw-translate-y: 32px !important;
  transform: translate(var(--tw-translate-x), 32px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[50\\%\\] {
  --tw-translate-y: 50% !important;
  transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90 {
  --tw-rotate: 90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-0 {
  --tw-scale-x: 0 !important;
  --tw-scale-y: 0 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0) scaleY(0) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-100 {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-150 {
  --tw-scale-x: 1.5 !important;
  --tw-scale-y: 1.5 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.5) scaleY(1.5) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-95 {
  --tw-scale-x: .95 !important;
  --tw-scale-y: .95 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-\\[0\\.2\\] {
  --tw-scale-x: 0.2 !important;
  --tw-scale-y: 0.2 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.2) scaleY(0.2) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-\\[107\\%\\] {
  --tw-scale-x: 107% !important;
  --tw-scale-y: 107% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(107%) scaleY(107%) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.animate-\\[shake_1s_linear_infinite\\] {
  animation: shake 1s linear infinite !important;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes showup {

  0% {
    opacity: 0;
    transform: translateY(0);
  }

  50% {
    opacity: 1;
    transform: translateY(-100%);
  }

  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.animate-showup {
  animation: showup 2s ease-in-out 0s 1 forwards !important;
}
.cursor-default {
  cursor: default !important;
}
.cursor-help {
  cursor: help !important;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.cursor-text {
  cursor: text !important;
}
.select-none {
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}
.resize {
  resize: both !important;
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
}
.grid-cols-\\[auto_1fr_1fr_1fr\\] {
  grid-template-columns: auto 1fr 1fr 1fr !important;
}
.grid-cols-\\[repeat\\(1\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(1,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(2\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(2,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(3\\2c 30px\\)\\] {
  grid-template-columns: repeat(3,30px) !important;
}
.grid-cols-\\[repeat\\(3\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(3,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(4\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(4,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(5\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(5,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(6\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(6,minmax(auto,1fr)) !important;
}
.grid-cols-\\[repeat\\(7\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(7,minmax(auto,1fr)) !important;
}
.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex-row-reverse {
  flex-direction: row-reverse !important;
}
.flex-col {
  flex-direction: column !important;
}
.flex-col-reverse {
  flex-direction: column-reverse !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
.content-center {
  align-content: center !important;
}
.content-start {
  align-content: flex-start !important;
}
.content-baseline {
  align-content: baseline !important;
}
.items-start {
  align-items: flex-start !important;
}
.items-end {
  align-items: flex-end !important;
}
.items-center {
  align-items: center !important;
}
.items-baseline {
  align-items: baseline !important;
}
.items-stretch {
  align-items: stretch !important;
}
.justify-start {
  justify-content: flex-start !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.justify-center {
  justify-content: center !important;
}
.justify-between {
  justify-content: space-between !important;
}
.justify-around {
  justify-content: space-around !important;
}
.justify-evenly {
  justify-content: space-evenly !important;
}
.justify-stretch {
  justify-content: stretch !important;
}
.\\!gap-0 {
  gap: 0px !important;
}
.gap-0 {
  gap: 0px !important;
}
.gap-0\\.5 {
  gap: 2px !important;
}
.gap-1 {
  gap: 4px !important;
}
.gap-1\\.5 {
  gap: 6px !important;
}
.gap-10 {
  gap: 40px !important;
}
.gap-2 {
  gap: 8px !important;
}
.gap-3 {
  gap: 12px !important;
}
.gap-4 {
  gap: 16px !important;
}
.gap-5 {
  gap: 20px !important;
}
.gap-6 {
  gap: 24px !important;
}
.gap-8 {
  gap: 32px !important;
}
.gap-\\[10px\\] {
  gap: 10px !important;
}
.gap-\\[2px\\] {
  gap: 2px !important;
}
.gap-\\[3\\%\\] {
  gap: 3% !important;
}
.gap-\\[32px\\] {
  gap: 32px !important;
}
.gap-\\[3px\\] {
  gap: 3px !important;
}
.gap-\\[4em\\] {
  gap: 4em !important;
}
.gap-x-1 {
  -moz-column-gap: 4px !important;
       column-gap: 4px !important;
}
.gap-x-1\\.5 {
  -moz-column-gap: 6px !important;
       column-gap: 6px !important;
}
.gap-x-10 {
  -moz-column-gap: 40px !important;
       column-gap: 40px !important;
}
.gap-x-2 {
  -moz-column-gap: 8px !important;
       column-gap: 8px !important;
}
.gap-x-3 {
  -moz-column-gap: 12px !important;
       column-gap: 12px !important;
}
.gap-x-4 {
  -moz-column-gap: 16px !important;
       column-gap: 16px !important;
}
.gap-x-\\[-2px\\] {
  -moz-column-gap: -2px !important;
       column-gap: -2px !important;
}
.gap-x-\\[10px\\] {
  -moz-column-gap: 10px !important;
       column-gap: 10px !important;
}
.gap-x-\\[6px\\] {
  -moz-column-gap: 6px !important;
       column-gap: 6px !important;
}
.gap-y-0 {
  row-gap: 0px !important;
}
.gap-y-0\\.5 {
  row-gap: 2px !important;
}
.gap-y-1 {
  row-gap: 4px !important;
}
.gap-y-1\\.5 {
  row-gap: 6px !important;
}
.gap-y-16 {
  row-gap: 64px !important;
}
.gap-y-2 {
  row-gap: 8px !important;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem !important;
}
.gap-y-3 {
  row-gap: 12px !important;
}
.gap-y-4 {
  row-gap: 16px !important;
}
.gap-y-5 {
  row-gap: 20px !important;
}
.gap-y-6 {
  row-gap: 24px !important;
}
.gap-y-\\[10px\\] {
  row-gap: 10px !important;
}
.gap-y-\\[4px\\] {
  row-gap: 4px !important;
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(6px * 0) !important;
  margin-right: calc(6px * var(--tw-space-x-reverse)) !important;
  margin-left: calc(6px * (1 - 0)) !important;
  margin-left: calc(6px * (1 - var(--tw-space-x-reverse))) !important;
  margin-left: calc(6px * calc(1 - 0)) !important;
  margin-left: calc(6px * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(8px * 0) !important;
  margin-right: calc(8px * var(--tw-space-x-reverse)) !important;
  margin-left: calc(8px * (1 - 0)) !important;
  margin-left: calc(8px * (1 - var(--tw-space-x-reverse))) !important;
  margin-left: calc(8px * calc(1 - 0)) !important;
  margin-left: calc(8px * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(12px * (1 - 0)) !important;
  margin-top: calc(12px * (1 - var(--tw-space-y-reverse))) !important;
  margin-top: calc(12px * calc(1 - 0)) !important;
  margin-top: calc(12px * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(12px * 0) !important;
  margin-bottom: calc(12px * var(--tw-space-y-reverse)) !important;
}
.self-end {
  align-self: flex-end !important;
}
.self-center {
  align-self: center !important;
}
.self-stretch {
  align-self: stretch !important;
}
.justify-self-end {
  justify-self: end !important;
}
.justify-self-stretch {
  justify-self: stretch !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-x-auto {
  overflow-x: auto !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-x-scroll {
  overflow-x: scroll !important;
}
.overflow-y-scroll {
  overflow-y: scroll !important;
}
.truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.whitespace-nowrap {
  white-space: nowrap !important;
}
.text-nowrap {
  text-wrap: nowrap !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-2xl {
  border-radius: 1rem !important;
}
.rounded-full {
  border-radius: 9999px !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-md {
  border-radius: 0.375rem !important;
}
.rounded-none {
  border-radius: 0px !important;
}
.rounded-sm {
  border-radius: 0.125rem !important;
}
.rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}
.border {
  border-width: 1px !important;
}
.border-0 {
  border-width: 0px !important;
}
.border-2 {
  border-width: 2px !important;
}
.border-4 {
  border-width: 4px !important;
}
.border-\\[1px\\] {
  border-width: 1px !important;
}
.border-\\[3px\\] {
  border-width: 3px !important;
}
.border-x {
  border-left-width: 1px !important;
  border-right-width: 1px !important;
}
.border-y-2 {
  border-top-width: 2px !important;
  border-bottom-width: 2px !important;
}
.border-l-\\[10px\\] {
  border-left-width: 10px !important;
}
.border-r {
  border-right-width: 1px !important;
}
.border-r-\\[10px\\] {
  border-right-width: 10px !important;
}
.border-t {
  border-top-width: 1px !important;
}
.border-t-\\[14px\\] {
  border-top-width: 14px !important;
}
.border-solid {
  border-style: solid !important;
}
.border-none {
  border-style: none !important;
}
.border-\\[\\#0DE979\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgba(13, 233, 121, 1) !important;
  border-color: rgba(13, 233, 121, var(--tw-border-opacity)) !important;
}
.border-\\[\\#96a5b6\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgba(150, 165, 182, 1) !important;
  border-color: rgba(150, 165, 182, var(--tw-border-opacity)) !important;
}
.border-amber-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(180, 83, 9, 1) !important;
  border-color: rgba(180, 83, 9, var(--tw-border-opacity)) !important;
}
.border-blue-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(219, 234, 254, 1) !important;
  border-color: rgba(219, 234, 254, var(--tw-border-opacity)) !important;
}
.border-brand-purple-light {
  border-color: var(--brand-purple-light) !important;
}
.border-brand-purple-normal {
  border-color: var(--brand-purple) !important;
}
.border-error {
  border-color: var(--error) !important;
}
.border-gray-300 {
  border-color: var(--gray-300) !important;
}
.border-gray-400 {
  border-color: var(--gray-400) !important;
}
.border-gray-50 {
  border-color: var(--gray-50) !important;
}
.border-gray-500 {
  border-color: var(--gray-500) !important;
}
.border-gray-600 {
  border-color: var(--gray-600) !important;
}
.border-gray-700 {
  border-color: var(--gray-700) !important;
}
.border-gray-800 {
  border-color: var(--gray-800) !important;
}
.border-gray-900 {
  border-color: var(--gray-900) !important;
}
.border-green-500 {
  border-color: var(--green-500) !important;
}
.border-lime-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(132, 204, 22, 1) !important;
  border-color: rgba(132, 204, 22, var(--tw-border-opacity)) !important;
}
.border-pink-700 {
  border-color: var(--pink-700) !important;
}
.border-rose-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(253, 164, 175, 1) !important;
  border-color: rgba(253, 164, 175, var(--tw-border-opacity)) !important;
}
.border-rose-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(225, 29, 72, 1) !important;
  border-color: rgba(225, 29, 72, var(--tw-border-opacity)) !important;
}
.border-teal-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(94, 234, 212, 1) !important;
  border-color: rgba(94, 234, 212, var(--tw-border-opacity)) !important;
}
.border-teal-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(20, 184, 166, 1) !important;
  border-color: rgba(20, 184, 166, var(--tw-border-opacity)) !important;
}
.border-transparent {
  border-color: transparent !important;
}
.border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgba(255, 255, 255, 1) !important;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity)) !important;
}
.border-l-transparent {
  border-left-color: transparent !important;
}
.border-r-transparent {
  border-right-color: transparent !important;
}
.border-t-gray-700 {
  border-top-color: var(--gray-700) !important;
}
.\\!bg-gray-700 {
  background-color: var(--gray-700) !important;
}
.bg-\\[\\#02040966\\] {
  background-color: rgba(2,4,9,0.4) !important;
}
.bg-\\[\\#080D1899\\] {
  background-color: rgba(8,13,24,0.6) !important;
}
.bg-\\[\\#080D18\\]\\/60 {
  background-color: rgba(8, 13, 24, 0.6) !important;
}
.bg-\\[\\#10b981\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(16, 185, 129, 1) !important;
  background-color: rgba(16, 185, 129, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#132039\\]\\/30 {
  background-color: rgba(19, 32, 57, 0.3) !important;
}
.bg-\\[\\#161032\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(22, 16, 50, 1) !important;
  background-color: rgba(22, 16, 50, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#19213499\\] {
  background-color: rgba(25,33,52,0.6) !important;
}
.bg-\\[\\#1B182B\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(27, 24, 43, 1) !important;
  background-color: rgba(27, 24, 43, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#233070\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(35, 48, 112, 1) !important;
  background-color: rgba(35, 48, 112, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#2A8F7D\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(42, 143, 125, 1) !important;
  background-color: rgba(42, 143, 125, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#341772\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(52, 23, 114, 1) !important;
  background-color: rgba(52, 23, 114, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#443077\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(68, 48, 119, 1) !important;
  background-color: rgba(68, 48, 119, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#494D6F\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(73, 77, 111, 1) !important;
  background-color: rgba(73, 77, 111, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#6A03E259\\] {
  background-color: rgba(106,3,226,0.34902) !important;
}
.bg-\\[\\#9333f3\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(147, 51, 243, 1) !important;
  background-color: rgba(147, 51, 243, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#C44371\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(196, 67, 113, 1) !important;
  background-color: rgba(196, 67, 113, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#FA213D\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(250, 33, 61, 1) !important;
  background-color: rgba(250, 33, 61, var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#FF6197\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(255, 97, 151, 1) !important;
  background-color: rgba(255, 97, 151, var(--tw-bg-opacity)) !important;
}
.bg-\\[rgba\\(19\\2c 32\\2c 57\\2c 0\\.3\\)\\] {
  background-color: rgba(19,32,57,0.3) !important;
}
.bg-\\[var\\(--plinko-tag-100\\)\\] {
  background-color: var(--plinko-tag-100) !important;
}
.bg-\\[var\\(--plinko-tag-200\\)\\] {
  background-color: var(--plinko-tag-200) !important;
}
.bg-\\[var\\(--plinko-tag-300\\)\\] {
  background-color: var(--plinko-tag-300) !important;
}
.bg-\\[var\\(--plinko-tag-400\\)\\] {
  background-color: var(--plinko-tag-400) !important;
}
.bg-\\[var\\(--plinko-tag-500\\)\\] {
  background-color: var(--plinko-tag-500) !important;
}
.bg-\\[var\\(--plinko-tag-600\\)\\] {
  background-color: var(--plinko-tag-600) !important;
}
.bg-\\[var\\(--plinko-tag-700\\)\\] {
  background-color: var(--plinko-tag-700) !important;
}
.bg-amber-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(245, 158, 11, 1) !important;
  background-color: rgba(245, 158, 11, var(--tw-bg-opacity)) !important;
}
.bg-amber-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(217, 119, 6, 1) !important;
  background-color: rgba(217, 119, 6, var(--tw-bg-opacity)) !important;
}
.bg-amber-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(146, 64, 14, 1) !important;
  background-color: rgba(146, 64, 14, var(--tw-bg-opacity)) !important;
}
.bg-amber-900 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(120, 53, 15, 1) !important;
  background-color: rgba(120, 53, 15, var(--tw-bg-opacity)) !important;
}
.bg-black-700 {
  background-color: var(--general-bg) !important;
}
.bg-brand-pink-light {
  background-color: var(--brand-pink-light) !important;
}
.bg-brand-pink-normal {
  background-color: var(--brand-pink) !important;
}
.bg-brand-purple-dark-1 {
  background-color: var(--brand-purple-dark-1) !important;
}
.bg-brand-purple-light {
  background-color: var(--brand-purple-light) !important;
}
.bg-brand-warning {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(168, 89, 35, 1) !important;
  background-color: rgba(168, 89, 35, var(--tw-bg-opacity)) !important;
}
.bg-emerald-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(110, 231, 183, 1) !important;
  background-color: rgba(110, 231, 183, var(--tw-bg-opacity)) !important;
}
.bg-emerald-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(16, 185, 129, 1) !important;
  background-color: rgba(16, 185, 129, var(--tw-bg-opacity)) !important;
}
.bg-emerald-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(6, 95, 70, 1) !important;
  background-color: rgba(6, 95, 70, var(--tw-bg-opacity)) !important;
}
.bg-fuchsia-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(232, 121, 249, 1) !important;
  background-color: rgba(232, 121, 249, var(--tw-bg-opacity)) !important;
}
.bg-global-bg {
  background-color: var(--general-bg) !important;
}
.bg-gray-200 {
  background-color: var(--gray-200) !important;
}
.bg-gray-400 {
  background-color: var(--gray-400) !important;
}
.bg-gray-50 {
  background-color: var(--gray-50) !important;
}
.bg-gray-500 {
  background-color: var(--gray-500) !important;
}
.bg-gray-600 {
  background-color: var(--gray-600) !important;
}
.bg-gray-700 {
  background-color: var(--gray-700) !important;
}
.bg-gray-800 {
  background-color: var(--gray-800) !important;
}
.bg-gray-900 {
  background-color: var(--gray-900) !important;
}
.bg-gray-950 {
  background-color: var(--gray-950) !important;
}
.bg-green-500 {
  background-color: var(--green-500) !important;
}
.bg-green-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(21, 128, 61, 1) !important;
  background-color: rgba(21, 128, 61, var(--tw-bg-opacity)) !important;
}
.bg-inherit {
  background-color: inherit !important;
}
.bg-lime-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(101, 163, 13, 1) !important;
  background-color: rgba(101, 163, 13, var(--tw-bg-opacity)) !important;
}
.bg-pink-700 {
  background-color: var(--pink-700) !important;
}
.bg-purple-400 {
  background-color: var(--purple-400) !important;
}
.bg-purple-500 {
  background-color: var(--purple-500) !important;
}
.bg-purple-600 {
  background-color: var(--purple-600) !important;
}
.bg-red-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(239, 68, 68, 1) !important;
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity)) !important;
}
.bg-red-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(153, 27, 27, 1) !important;
  background-color: rgba(153, 27, 27, var(--tw-bg-opacity)) !important;
}
.bg-response-error {
  background-color: var(--error) !important;
}
.bg-response-success {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(105, 209, 191, 1) !important;
  background-color: rgba(105, 209, 191, var(--tw-bg-opacity)) !important;
}
.bg-response-warning {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(233, 162, 59, 1) !important;
  background-color: rgba(233, 162, 59, var(--tw-bg-opacity)) !important;
}
.bg-rose-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(244, 63, 94, 1) !important;
  background-color: rgba(244, 63, 94, var(--tw-bg-opacity)) !important;
}
.bg-rose-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(225, 29, 72, 1) !important;
  background-color: rgba(225, 29, 72, var(--tw-bg-opacity)) !important;
}
.bg-rose-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(190, 18, 60, 1) !important;
  background-color: rgba(190, 18, 60, var(--tw-bg-opacity)) !important;
}
.bg-rose-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(159, 18, 57, 1) !important;
  background-color: rgba(159, 18, 57, var(--tw-bg-opacity)) !important;
}
.bg-rose-900 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(136, 19, 55, 1) !important;
  background-color: rgba(136, 19, 55, var(--tw-bg-opacity)) !important;
}
.bg-rose-950 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(76, 5, 25, 1) !important;
  background-color: rgba(76, 5, 25, var(--tw-bg-opacity)) !important;
}
.bg-teal-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(45, 212, 191, 1) !important;
  background-color: rgba(45, 212, 191, var(--tw-bg-opacity)) !important;
}
.bg-teal-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(20, 184, 166, 1) !important;
  background-color: rgba(20, 184, 166, var(--tw-bg-opacity)) !important;
}
.bg-teal-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(13, 148, 136, 1) !important;
  background-color: rgba(13, 148, 136, var(--tw-bg-opacity)) !important;
}
.bg-teal-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(15, 118, 110, 1) !important;
  background-color: rgba(15, 118, 110, var(--tw-bg-opacity)) !important;
}
.bg-teal-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(17, 94, 89, 1) !important;
  background-color: rgba(17, 94, 89, var(--tw-bg-opacity)) !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(255, 255, 255, 1) !important;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity)) !important;
}
.bg-white\\/10 {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9 !important;
}
.bg-\\[image\\:var\\(--image-url\\)\\] {
  background-image: var(--image-url) !important;
}
.bg-\\[linear-gradient\\(90deg\\2c _\\#439288_0\\%\\2c \\#56B5A6_100\\%\\)\\] {
  background-image: linear-gradient(90deg, #439288 0%,#56B5A6 100%) !important;
}
.bg-\\[linear-gradient\\(90deg\\2c _\\#CF364C_0\\%\\2c \\#E14F62_100\\%\\)\\] {
  background-image: linear-gradient(90deg, #CF364C 0%,#E14F62 100%) !important;
}
.bg-brand-mixed-gradient {
  background-image: linear-gradient(to right, var(--brand-purple), var(--brand-pink)) !important;
}
.bg-brand-mixed-gradient-1 {
  background-image: linear-gradient(to right, var(--brand-mixed-start-1), var(--brand-pink)) !important;
}
.bg-brand-purple-gradient-1 {
  background-image: linear-gradient(to right, var(--brand-purple-dark-1), var(--brand-purple)) !important;
}
.bg-coin-lost-gradient {
  background-image: linear-gradient(163.49deg, #131823 14.75%, #511D33 84.35%) !important;
}
.bg-coin-won-gradient {
  background-image: linear-gradient(163.49deg, #131823 14.75%, #2B5C4D 84.35%) !important;
}
.bg-divvy-bg-gradient {
  background-image: linear-gradient(60deg, #1f1149, #0e533b) !important;
}
.bg-divvy-gradient {
  background-image: radial-gradient(circle at -62% 166%, #7c01ff, #00d77d 112%) !important;
}
.bg-divvy-gradient-transparent {
  background-image: radial-gradient(121.47% 136.9% at -0.95% 100%, rgba(115, 0, 246, 0.4) 0%, rgba(13, 233, 121, 0.4) 100%) !important;
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops)) !important;
}
.bg-limbo-idle-gradient {
  background-image: linear-gradient(to bottom, #131823, #232C3F) !important;
}
.bg-limbo-lost-gradient {
  background-image: linear-gradient(to bottom, #131823, #531C33) !important;
}
.bg-limbo-won-gradient {
  background-image: linear-gradient(to bottom, #131823, #224E4C) !important;
}
.bg-none {
  background-image: none !important;
}
.bg-side-tag-gold {
  background-image: linear-gradient(95.4deg,var(--gold-300) 27.12%, var(--gold-200) 66.55%, var(--gold-300) 90.34%) !important;
}
.from-\\[\\#571094\\] {
  --tw-gradient-from: #571094 var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgba(87, 16, 148, 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-gray-50-alpha\\/10 {
  --tw-gradient-from: rgba(var(--gray-50-rgb), 0.1) var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgba(var(--gray-50-rgb), 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-20\\% {
  --tw-gradient-from-position: 20% !important;
}
.via-\\[\\#481387\\] {
  --tw-gradient-to: rgba(72, 19, 135, 0)  var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), #481387 var(--tw-gradient-via-position), var(--tw-gradient-to) !important;
}
.via-40\\% {
  --tw-gradient-via-position: 40% !important;
}
.to-\\[\\#351673\\] {
  --tw-gradient-to: #351673 var(--tw-gradient-to-position) !important;
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position) !important;
}
.bg-\\[length\\:400\\%\\] {
  background-size: 400% !important;
}
.bg-contain {
  background-size: contain !important;
}
.bg-cover {
  background-size: cover !important;
}
.bg-fixed {
  background-attachment: fixed !important;
}
.bg-\\[center_bottom_0\\] {
  background-position: center bottom 0 !important;
}
.bg-\\[center_bottom_19\\.67\\%\\] {
  background-position: center bottom 19.67% !important;
}
.bg-\\[center_bottom_40\\.34\\%\\] {
  background-position: center bottom 40.34% !important;
}
.bg-\\[center_top_19\\.67\\%\\] {
  background-position: center top 19.67% !important;
}
.bg-\\[left_25\\%_center\\] {
  background-position: left 25% center !important;
}
.bg-\\[left_50\\%_center\\] {
  background-position: left 50% center !important;
}
.bg-\\[left_75\\%_center\\] {
  background-position: left 75% center !important;
}
.bg-\\[left_center\\] {
  background-position: left center !important;
}
.bg-center {
  background-position: center !important;
}
.bg-top {
  background-position: top !important;
}
.bg-no-repeat {
  background-repeat: no-repeat !important;
}
.fill-green-900 {
  fill: #14532d !important;
}
.stroke-current {
  stroke: currentColor !important;
}
.p-0 {
  padding: 0px !important;
}
.p-1 {
  padding: 4px !important;
}
.p-1\\.5 {
  padding: 6px !important;
}
.p-2 {
  padding: 8px !important;
}
.p-3 {
  padding: 12px !important;
}
.p-4 {
  padding: 16px !important;
}
.p-5 {
  padding: 20px !important;
}
.p-6 {
  padding: 24px !important;
}
.p-8 {
  padding: 32px !important;
}
.p-\\[10px\\] {
  padding: 10px !important;
}
.p-\\[5px\\] {
  padding: 5px !important;
}
.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.px-1\\.5 {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.px-2\\.5 {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.px-36 {
  padding-left: 9rem !important;
  padding-right: 9rem !important;
}
.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.px-\\[10px\\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.px-\\[4\\.5px\\] {
  padding-left: 4.5px !important;
  padding-right: 4.5px !important;
}
.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.py-0\\.5 {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.py-1\\.5 {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.py-2\\.5 {
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.py-5\\.5 {
  padding-top: 22px !important;
  padding-bottom: 22px !important;
}
.py-\\[1px\\] {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.py-\\[2px\\] {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.py-\\[4\\.5px\\] {
  padding-top: 4.5px !important;
  padding-bottom: 4.5px !important;
}
.py-\\[5\\.5px\\] {
  padding-top: 5.5px !important;
  padding-bottom: 5.5px !important;
}
.pb-0 {
  padding-bottom: 0px !important;
}
.pb-10 {
  padding-bottom: 40px !important;
}
.pb-12 {
  padding-bottom: 48px !important;
}
.pb-2 {
  padding-bottom: 8px !important;
}
.pb-3 {
  padding-bottom: 12px !important;
}
.pb-4 {
  padding-bottom: 16px !important;
}
.pb-44 {
  padding-bottom: 11rem !important;
}
.pb-6 {
  padding-bottom: 24px !important;
}
.pb-\\[120px\\] {
  padding-bottom: 120px !important;
}
.pb-\\[16px\\] {
  padding-bottom: 16px !important;
}
.pb-\\[20\\.6\\%\\] {
  padding-bottom: 20.6% !important;
}
.pb-\\[60\\%\\] {
  padding-bottom: 60% !important;
}
.pb-\\[90px\\] {
  padding-bottom: 90px !important;
}
.pb-\\[var\\(--game-frame-tool-bar-height\\)\\] {
  padding-bottom: var(--game-frame-tool-bar-height) !important;
}
.pe-1 {
  padding-right: 4px !important;
}
.pl-3 {
  padding-left: 12px !important;
}
.pl-4 {
  padding-left: 16px !important;
}
.pl-7\\.5 {
  padding-left: 30px !important;
}
.pr-1 {
  padding-right: 4px !important;
}
.pr-2 {
  padding-right: 8px !important;
}
.pr-3 {
  padding-right: 12px !important;
}
.pr-5 {
  padding-right: 20px !important;
}
.ps-4 {
  padding-left: 16px !important;
}
.pt-0 {
  padding-top: 0px !important;
}
.pt-0\\.5 {
  padding-top: 2px !important;
}
.pt-1 {
  padding-top: 4px !important;
}
.pt-1\\.5 {
  padding-top: 6px !important;
}
.pt-16 {
  padding-top: 64px !important;
}
.pt-2 {
  padding-top: 8px !important;
}
.pt-3 {
  padding-top: 12px !important;
}
.pt-4 {
  padding-top: 16px !important;
}
.pt-5 {
  padding-top: 20px !important;
}
.pt-\\[3px\\] {
  padding-top: 3px !important;
}
.pt-top-bar-and-banner-height {
  padding-top: var(--top-bar-and-banner-height) !important;
}
.pt-top-bar-height {
  padding-top: var(--top-bar-height) !important;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-\\[100\\%\\] {
  font-size: 100% !important;
}
.text-\\[10px\\] {
  font-size: 10px !important;
}
.text-\\[12px\\] {
  font-size: 12px !important;
}
.text-\\[14px\\] {
  font-size: 14px !important;
}
.text-\\[16px\\] {
  font-size: 16px !important;
}
.text-\\[18px\\] {
  font-size: 18px !important;
}
.text-\\[20px\\] {
  font-size: 20px !important;
}
.text-\\[24px\\] {
  font-size: 24px !important;
}
.text-\\[30px\\] {
  font-size: 30px !important;
}
.text-\\[48px\\] {
  font-size: 48px !important;
}
.text-\\[50px\\] {
  font-size: 50px !important;
}
.text-\\[62px\\] {
  font-size: 62px !important;
}
.text-\\[86px\\] {
  font-size: 86px !important;
}
.text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.font-black {
  font-weight: 700 !important;
}
.font-bold {
  font-weight: 600 !important;
}
.font-normal {
  font-weight: 400 !important;
}
.font-semibold {
  font-weight: 600 !important;
}
.font-thin {
  font-weight: 300 !important;
}
.uppercase {
  text-transform: uppercase !important;
}
.capitalize {
  text-transform: capitalize !important;
}
.leading-10 {
  line-height: 2.5rem !important;
}
.leading-3 {
  line-height: .75rem !important;
}
.leading-5 {
  line-height: 1.25rem !important;
}
.leading-6 {
  line-height: 1.5rem !important;
}
.leading-8 {
  line-height: 2rem !important;
}
.leading-\\[30px\\] {
  line-height: 30px !important;
}
.leading-\\[95px\\] {
  line-height: 95px !important;
}
.leading-none {
  line-height: 1 !important;
}
.text-\\[\\#96a5b6\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(150, 165, 182, 1) !important;
  color: rgba(150, 165, 182, var(--tw-text-opacity)) !important;
}
.text-\\[\\#FFFFFF73\\] {
  color: rgba(255,255,255,0.45098) !important;
}
.text-amber-300 {
  --tw-text-opacity: 1 !important;
  color: rgba(252, 211, 77, 1) !important;
  color: rgba(252, 211, 77, var(--tw-text-opacity)) !important;
}
.text-blue-600 {
  --tw-text-opacity: 1 !important;
  color: rgba(37, 99, 235, 1) !important;
  color: rgba(37, 99, 235, var(--tw-text-opacity)) !important;
}
.text-brand-pink-regular {
  color: var(--brand-pink) !important;
}
.text-current {
  color: currentColor !important;
}
.text-emerald-500 {
  --tw-text-opacity: 1 !important;
  color: rgba(16, 185, 129, 1) !important;
  color: rgba(16, 185, 129, var(--tw-text-opacity)) !important;
}
.text-error {
  color: var(--error) !important;
}
.text-gold-100 {
  color: var(--gold-100) !important;
}
.text-gold-200 {
  color: var(--gold-200) !important;
}
.text-gray-100 {
  color: var(--gray-100) !important;
}
.text-gray-200 {
  color: var(--gray-200) !important;
}
.text-gray-300 {
  color: var(--gray-300) !important;
}
.text-gray-400 {
  color: var(--gray-400) !important;
}
.text-gray-50 {
  color: var(--gray-50) !important;
}
.text-gray-500 {
  color: var(--gray-500) !important;
}
.text-gray-700 {
  color: var(--gray-700) !important;
}
.text-gray-800 {
  color: var(--gray-800) !important;
}
.text-gray-900 {
  color: var(--gray-900) !important;
}
.text-gray-950 {
  color: var(--gray-950) !important;
}
.text-green-500 {
  color: var(--green-500) !important;
}
.text-green-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(21, 128, 61, 1) !important;
  color: rgba(21, 128, 61, var(--tw-text-opacity)) !important;
}
.text-leader-bronze {
  color: var(--leader-bronze) !important;
}
.text-leader-gold {
  color: var(--leader-gold) !important;
}
.text-leader-silver {
  color: var(--leader-silver) !important;
}
.text-lime-400 {
  --tw-text-opacity: 1 !important;
  color: rgba(163, 230, 53, 1) !important;
  color: rgba(163, 230, 53, var(--tw-text-opacity)) !important;
}
.text-lime-500 {
  --tw-text-opacity: 1 !important;
  color: rgba(132, 204, 22, 1) !important;
  color: rgba(132, 204, 22, var(--tw-text-opacity)) !important;
}
.text-pink-300 {
  --tw-text-opacity: 1 !important;
  color: rgba(249, 168, 212, 1) !important;
  color: rgba(249, 168, 212, var(--tw-text-opacity)) !important;
}
.text-pink-500 {
  --tw-text-opacity: 1 !important;
  color: rgba(236, 72, 153, 1) !important;
  color: rgba(236, 72, 153, var(--tw-text-opacity)) !important;
}
.text-purple-300 {
  color: var(--purple-300) !important;
}
.text-purple-500 {
  color: var(--purple-500) !important;
}
.text-purple-700 {
  color: var(--purple-700) !important;
}
.text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgba(220, 38, 38, 1) !important;
  color: rgba(220, 38, 38, var(--tw-text-opacity)) !important;
}
.text-response-error {
  color: var(--error) !important;
}
.text-slate-50 {
  --tw-text-opacity: 1 !important;
  color: rgba(248, 250, 252, 1) !important;
  color: rgba(248, 250, 252, var(--tw-text-opacity)) !important;
}
.text-teal-100 {
  --tw-text-opacity: 1 !important;
  color: rgba(204, 251, 241, 1) !important;
  color: rgba(204, 251, 241, var(--tw-text-opacity)) !important;
}
.text-teal-400 {
  --tw-text-opacity: 1 !important;
  color: rgba(45, 212, 191, 1) !important;
  color: rgba(45, 212, 191, var(--tw-text-opacity)) !important;
}
.text-white {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, 1) !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}
.underline {
  text-decoration-line: underline !important;
}
.opacity-0 {
  opacity: 0 !important;
}
.opacity-100 {
  opacity: 1 !important;
}
.opacity-25 {
  opacity: 0.25 !important;
}
.opacity-30 {
  opacity: 0.3 !important;
}
.opacity-40 {
  opacity: 0.4 !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
.opacity-60 {
  opacity: 0.6 !important;
}
.opacity-75 {
  opacity: 0.75 !important;
}
.opacity-80 {
  opacity: 0.8 !important;
}
.opacity-90 {
  opacity: 0.9 !important;
}
.mix-blend-multiply {
  mix-blend-mode: multiply !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-black-regular {
  --tw-shadow: 0px 4px 8px 0px var(--black-900) !important;
  --tw-shadow-colored: 0px 4px 8px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-brand-pink-sm {
  --tw-shadow: 0px 0px 12px 0px rgba(var(--brand-pink-light-rgb),0.4) !important;
  --tw-shadow-colored: 0px 0px 12px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-brand-pink-xs {
  --tw-shadow: 0px 0px 6px 0px rgba(var(--brand-pink-light-rgb),1) !important;
  --tw-shadow-colored: 0px 0px 6px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-brand-purple-sm {
  --tw-shadow: 0px 0px 12px 0px rgba(var(--brand-purple-rgb),0.4) !important;
  --tw-shadow-colored: 0px 0px 12px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-brand-regular {
  --tw-shadow: 0px 4px 16px 0px var(--gray-850) !important;
  --tw-shadow-colored: 0px 4px 16px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-bronze-glow-xl {
  --tw-shadow: 0px 0px 100px 0px #9A4E21; !important;
  --tw-shadow-colored: 0px 0px 100px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 100px 0px #9A4E21; !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-gold-glow {
  --tw-shadow: 0px 1px 12px 0px var(--gold-100); !important;
  --tw-shadow-colored: 0px 1px 12px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-gold-glow-xl {
  --tw-shadow: 0px 0px 100px 0px var(--gold-300); !important;
  --tw-shadow-colored: 0px 0px 100px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-silver-glow-xl {
  --tw-shadow: 0px 0px 100px 0px var(--silver-200); !important;
  --tw-shadow-colored: 0px 0px 100px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow-\\[\\#080D1899\\] {
  --tw-shadow-color: rgba(8,13,24,0.6) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-0 {
  outline-width: 0px !important;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.ring-inset {
  --tw-ring-inset: inset !important;
}
.ring-emerald-500 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgba(16, 185, 129, var(--tw-ring-opacity)) !important;
}
.ring-gray-50 {
  --tw-ring-color: var(--gray-50) !important;
}
.ring-pink-400 {
  --tw-ring-color: var(--pink-400) !important;
}
.ring-pink-500 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgba(236, 72, 153, var(--tw-ring-opacity)) !important;
}
.ring-teal-400 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgba(45, 212, 191, var(--tw-ring-opacity)) !important;
}
.blur {
  --tw-blur: blur(8px) !important;
  filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.blur-\\[1px\\] {
  --tw-blur: blur(1px) !important;
  filter: blur(1px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.blur-sm {
  --tw-blur: blur(4px) !important;
  filter: blur(4px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow-white-glow {
  --tw-drop-shadow: drop-shadow(0 0 6px rgba(255, 255, 255, 0.2)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 6px rgba(255, 255, 255, 0.2)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.grayscale {
  --tw-grayscale: grayscale(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) grayscale(100%) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.invert {
  --tw-invert: invert(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) invert(100%) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.sepia {
  --tw-sepia: sepia(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) sepia(100%) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: blur(8px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px) !important;
  -webkit-backdrop-filter: blur(40px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: blur(40px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-\\[clip-path\\] {
  transition-property: clip-path !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-opacity {
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-transform {
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-100 {
  transition-duration: 100ms !important;
}
.duration-200 {
  transition-duration: 200ms !important;
}
.duration-300 {
  transition-duration: 300ms !important;
}
.duration-75 {
  transition-duration: 75ms !important;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.scrollbar::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track) !important;
  border-radius: var(--scrollbar-track-radius) !important;
}
.scrollbar::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track)) !important;
}
.scrollbar::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track))) !important;
}
.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb) !important;
  border-radius: var(--scrollbar-thumb-radius) !important;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb)) !important;
}
.scrollbar::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb))) !important;
}
.scrollbar::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner) !important;
  border-radius: var(--scrollbar-corner-radius) !important;
}
.scrollbar::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner)) !important;
}
.scrollbar::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner))) !important;
}
.scrollbar {
  scrollbar-width: auto !important;
  scrollbar-color: initial initial !important;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial) !important;
}
.scrollbar::-webkit-scrollbar {
  display: block !important;
  width: 16px !important;
  width: var(--scrollbar-width, 16px) !important;
  height: 16px !important;
  height: var(--scrollbar-height, 16px) !important;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track) !important;
  border-radius: var(--scrollbar-track-radius) !important;
}
.scrollbar-thin::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track)) !important;
}
.scrollbar-thin::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track))) !important;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb) !important;
  border-radius: var(--scrollbar-thumb-radius) !important;
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb)) !important;
}
.scrollbar-thin::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb))) !important;
}
.scrollbar-thin::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner) !important;
  border-radius: var(--scrollbar-corner-radius) !important;
}
.scrollbar-thin::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner)) !important;
}
.scrollbar-thin::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner))) !important;
}
.scrollbar-thin {
  scrollbar-width: thin !important;
  scrollbar-color: initial initial !important;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial) !important;
}
.scrollbar-thin::-webkit-scrollbar {
  display: block !important;
  width: 8px !important;
  height: 8px !important;
}
.scrollbar-track-gray-900 {
  --scrollbar-track: var(--gray-900) !important;
}
.scrollbar-thumb-gray-600 {
  --scrollbar-thumb: var(--gray-600) !important;
}
.scrollbar-thumb-transparent {
  --scrollbar-thumb: transparent !important;
}
.scrollbar-track-rounded-full {
  --scrollbar-track-radius: 9999px !important;
}
.scrollbar-thumb-rounded-full {
  --scrollbar-thumb-radius: 9999px !important;
}
.\\@container {
  container-type: inline-size !important;
}
.\\@container\\/table {
  container-type: inline-size !important;
  container-name: table !important;
}
.gradient-mask-l-\\[transparent\\2c rgba\\(0\\2c 0\\2c 0\\2c 5\\)_30\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 1\\)_50\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 5\\)_70\\%\\2c transparent_100\\%\\] {
  -webkit-mask-image: linear-gradient(to left, transparent,rgba(0,0,0,5) 30%,rgba(0,0,0,1) 50%,rgba(0,0,0,5) 70%,transparent 100%, transparent 100%) !important;
          mask-image: linear-gradient(to left, transparent,rgba(0,0,0,5) 30%,rgba(0,0,0,1) 50%,rgba(0,0,0,5) 70%,transparent 100%, transparent 100%) !important;
}
.gradient-mask-t-\\[transparent\\2c rgba\\(0\\2c 0\\2c 0\\2c 1\\.0\\)_20\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 1\\)_100\\%\\] {
  -webkit-mask-image: linear-gradient(to top, transparent,rgba(0,0,0,1.0) 20%,rgba(0,0,0,1) 100%, transparent 100%) !important;
          mask-image: linear-gradient(to top, transparent,rgba(0,0,0,1.0) 20%,rgba(0,0,0,1) 100%, transparent 100%) !important;
}
.clip-unfold {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%) !important;
  }
.clip-fold {
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0) !important;
  }
.animate-pink-pulse {
    animation: pinkPulse 1s alternate infinite !important;
  }
.\\[backface-visibility\\:hidden\\] {
  backface-visibility: hidden !important;
}
.\\[box-shadow\\:0px_0px_12px_0px_rgba\\(207\\2c 54\\2c 76\\2c 0\\.50\\)\\] {
  box-shadow: 0px 0px 12px 0px rgba(207,54,76,0.50) !important;
}
.\\[box-shadow\\:0px_0px_12px_0px_rgba\\(86\\2c 181\\2c 166\\2c 0\\.50\\)\\] {
  box-shadow: 0px 0px 12px 0px rgba(86,181,166,0.50) !important;
}
.\\[box-shadow\\:inset_0px_-0\\.5em_0\\.2em_-0\\.3em_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\] {
  box-shadow: inset 0px -0.5em 0.2em -0.3em rgba(0,0,0,0.9) !important;
}
.\\[box-shadow\\:inset_0px_0\\.5em_0\\.2em_-0\\.3em_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\] {
  box-shadow: inset 0px 0.5em 0.2em -0.3em rgba(0,0,0,0.9) !important;
}
.\\[perspective\\:200px\\] {
  perspective: 200px !important;
}
.\\[transform-style\\:preserve-3d\\] {
  transform-style: preserve-3d !important;
}
.\\[transform\\:rotateY\\(-180deg\\)\\] {
  transform: rotateY(-180deg) !important;
}

@font-face {
  font-family: "zb-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_5___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Zeebit Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Zeebit Sans Caps";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Zeebit Numeric";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-weight: normal;
  font-style: normal;
  padding-bottom: "1em";
  padding-top: "10%";
}
@keyframes pinkPulse {
  0% {
    background: rgba(var(--brand-pink-rgb), 0.6);
    box-shadow: 0px 0px 8px 0 rgba(var(--brand-pink-rgb), 1);
  }
  100% {
    background: var(--gray-800);
    box-shadow: 0px 0px 6px 0 rgba(var(--brand-pink-rgb), 0);
  }
}
@keyframes shake {
  0%,
  100% {
    transform: translate(0, 0);
  }
  20% {
    transform: translate(calc(-3% * 0.4), calc(-3% * -0.2));
  }
  40% {
    transform: translate(calc(-3% * 0.5), calc(-3% * -0.5));
  }
  60% {
    transform: translate(calc(-3% * -0.3), calc(-3% * -0.3));
  }
  80% {
    transform: translate(calc(-3% * -0.4), calc(-3% * -0.2));
  }
}

.font-inter {
  font-family: "Inter", sans-serif;
}
.font-raleway {
  font-family: "Raleway", sans-serif;
}
.font-anton {
  font-family: "Anton", sans-serif;
}

.font-Satoshi {
  font-family: "Satoshi", "sans-serif";
}

.font-nunito {
  font-family: "Nunito", "sans-serif";
}

.font-zeebit-sans {
  font-family: "Zeebit Sans", sans-serif;
}

p {
  margin-bottom: 12px;
}
a {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
a:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.bottom-nav-shadow {
  box-shadow:
    0 -15px 10px -5px rgba(0, 0, 0, 0.2),
    0 8px 10px -6px rgba(0, 0, 0, 0.2);
}

.scroll-fix {
  -webkit-overflow-scrolling: touch;
}

.placeholder\\:text-gray-400::-moz-placeholder {
  color: var(--gray-400) !important;
}

.placeholder\\:text-gray-400::placeholder {
  color: var(--gray-400) !important;
}

.before\\:font-bold::before {
  content: var(--tw-content) !important;
  font-weight: 600 !important;
}

.before\\:font-normal::before {
  content: var(--tw-content) !important;
  font-weight: 400 !important;
}

.after\\:absolute::after {
  content: var(--tw-content) !important;
  position: absolute !important;
}

.after\\:left-0::after {
  content: var(--tw-content) !important;
  left: 0px !important;
}

.after\\:top-0::after {
  content: var(--tw-content) !important;
  top: 0px !important;
}

.after\\:block::after {
  content: var(--tw-content) !important;
  display: block !important;
}

.after\\:h-full::after {
  content: var(--tw-content) !important;
  height: 100% !important;
}

.after\\:w-full::after {
  content: var(--tw-content) !important;
  width: 100% !important;
}

.after\\:rounded::after {
  content: var(--tw-content) !important;
  border-radius: 0.25rem !important;
}

.after\\:rounded-lg::after {
  content: var(--tw-content) !important;
  border-radius: 0.5rem !important;
}

.after\\:rounded-md::after {
  content: var(--tw-content) !important;
  border-radius: 0.375rem !important;
}

.after\\:border-2::after {
  content: var(--tw-content) !important;
  border-width: 2px !important;
}

.after\\:border-gray-50::after {
  content: var(--tw-content) !important;
  border-color: var(--gray-50) !important;
}

.after\\:opacity-0::after {
  content: var(--tw-content) !important;
  opacity: 0 !important;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '' !important;
  content: '' !important;
  content: var(--tw-content) !important;
}

.first\\:-mt-3:first-child {
  margin-top: -12px !important;
}

.first\\:justify-start:first-child {
  justify-content: flex-start !important;
}

.first\\:justify-center:first-child {
  justify-content: center !important;
}

.first\\:rounded-l-md:first-child {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.first\\:rounded-s-md:first-child {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.first\\:border-s-2:first-child {
  border-left-width: 2px !important;
}

.first\\:pl-3:first-child {
  padding-left: 12px !important;
}

.first\\:text-left:first-child {
  text-align: left !important;
}

.last\\:justify-end:last-child {
  justify-content: flex-end !important;
}

.last\\:justify-center:last-child {
  justify-content: center !important;
}

.last\\:rounded-e-md:last-child {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.last\\:rounded-r-md:last-child {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.last\\:border-e-2:last-child {
  border-right-width: 2px !important;
}

.last\\:pr-3:last-child {
  padding-right: 12px !important;
}

.last\\:text-right:last-child {
  text-align: right !important;
}

.odd\\:bg-gray-700:nth-child(odd) {
  background-color: var(--gray-700) !important;
}

.group\\/row:nth-child(odd) .group-odd\\/row\\:bg-gray-700 {
  background-color: var(--gray-700) !important;
}

.group\\/row:nth-child(even) .group-even\\/row\\:bg-gray-800 {
  background-color: var(--gray-800) !important;
}

.group\\/row:hover .group-hover\\/row\\:bg-gray-600 {
  background-color: var(--gray-600) !important;
}

.group\\/row:active .group-active\\/row\\:bg-gray-700 {
  background-color: var(--gray-700) !important;
}

.hover\\:-translate-y-3:hover {
  --tw-translate-y: -12px !important;
  transform: translate(var(--tw-translate-x), -12px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:border-gray-500:hover {
  border-color: var(--gray-500) !important;
}

.hover\\:border-gray-600:hover {
  border-color: var(--gray-600) !important;
}

.hover\\:border-red-800:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgba(153, 27, 27, 1) !important;
  border-color: rgba(153, 27, 27, var(--tw-border-opacity)) !important;
}

.hover\\:bg-\\[\\#FF6197\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(255, 97, 151, 1) !important;
  background-color: rgba(255, 97, 151, var(--tw-bg-opacity)) !important;
}

.hover\\:bg-brand-purple-light:hover {
  background-color: var(--brand-purple-light) !important;
}

.hover\\:bg-emerald-300:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(110, 231, 183, 1) !important;
  background-color: rgba(110, 231, 183, var(--tw-bg-opacity)) !important;
}

.hover\\:bg-gray-400:hover {
  background-color: var(--gray-400) !important;
}

.hover\\:bg-gray-50:hover {
  background-color: var(--gray-50) !important;
}

.hover\\:bg-gray-50-alpha\\/10:hover {
  background-color: rgba(var(--gray-50-rgb), 0.1) !important;
}

.hover\\:bg-gray-500:hover {
  background-color: var(--gray-500) !important;
}

.hover\\:bg-gray-600:hover {
  background-color: var(--gray-600) !important;
}

.hover\\:bg-gray-700:hover {
  background-color: var(--gray-700) !important;
}

.hover\\:bg-gray-800:hover {
  background-color: var(--gray-800) !important;
}

.hover\\:bg-gray-900:hover {
  background-color: var(--gray-900) !important;
}

.hover\\:bg-teal-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(45, 212, 191, 1) !important;
  background-color: rgba(45, 212, 191, var(--tw-bg-opacity)) !important;
}

.hover\\:bg-teal-500:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(20, 184, 166, 1) !important;
  background-color: rgba(20, 184, 166, var(--tw-bg-opacity)) !important;
}

.hover\\:bg-teal-600:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(13, 148, 136, 1) !important;
  background-color: rgba(13, 148, 136, var(--tw-bg-opacity)) !important;
}

.hover\\:bg-transparent:hover {
  background-color: transparent !important;
}

.hover\\:bg-white\\/20:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.hover\\:text-gray-200:hover {
  color: var(--gray-200) !important;
}

.hover\\:text-gray-300:hover {
  color: var(--gray-300) !important;
}

.hover\\:text-gray-50:hover {
  color: var(--gray-50) !important;
}

.hover\\:text-gray-950:hover {
  color: var(--gray-950) !important;
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, 1) !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}

.hover\\:underline:hover {
  text-decoration-line: underline !important;
}

.hover\\:opacity-100:hover {
  opacity: 1 !important;
}

.hover\\:opacity-90:hover {
  opacity: 0.9 !important;
}

.hover\\:shadow-brand-purple-lg:hover {
  --tw-shadow: 0px 0px 20px 0px rgba(var(--brand-purple-rgb),0.6) !important;
  --tw-shadow-colored: 0px 0px 20px 0px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}

.hover\\:after\\:border-brand-purple-light:hover::after {
  content: var(--tw-content) !important;
  border-color: var(--brand-purple-light) !important;
}

.hover\\:after\\:border-gray-800:hover::after {
  content: var(--tw-content) !important;
  border-color: var(--gray-800) !important;
}

.hover\\:after\\:opacity-0:hover::after {
  content: var(--tw-content) !important;
  opacity: 0 !important;
}

.hover\\:after\\:opacity-100:hover::after {
  content: var(--tw-content) !important;
  opacity: 1 !important;
}

.even\\:hover\\:bg-gray-500:hover:nth-child(even) {
  background-color: var(--gray-500) !important;
}

.focus\\:border-0:focus {
  border-width: 0px !important;
}

.focus\\:border-2:focus {
  border-width: 2px !important;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 rgba(0,0,0,0) !important;
  --tw-shadow-colored: 0 0 rgba(0,0,0,0) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.active\\:border-\\[var\\(--brand-purple-dark-1\\)\\]:active {
  border-color: var(--brand-purple-dark-1) !important;
}

.active\\:border-gray-500:active {
  border-color: var(--gray-500) !important;
}

.active\\:bg-\\[\\#132039\\]\\/30:active {
  background-color: rgba(19, 32, 57, 0.3) !important;
}

.active\\:bg-\\[var\\(--brand-purple-dark-1\\)\\]:active {
  background-color: var(--brand-purple-dark-1) !important;
}

.active\\:bg-brand-purple-dark-1:active {
  background-color: var(--brand-purple-dark-1) !important;
}

.active\\:bg-gray-500:active {
  background-color: var(--gray-500) !important;
}

.active\\:bg-gray-600:active {
  background-color: var(--gray-600) !important;
}

.active\\:bg-gray-700:active {
  background-color: var(--gray-700) !important;
}

.active\\:bg-gray-800:active {
  background-color: var(--gray-800) !important;
}

.active\\:bg-gray-900:active {
  background-color: var(--gray-900) !important;
}

.active\\:bg-teal-400:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(45, 212, 191, 1) !important;
  background-color: rgba(45, 212, 191, var(--tw-bg-opacity)) !important;
}

.active\\:bg-teal-600:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(13, 148, 136, 1) !important;
  background-color: rgba(13, 148, 136, var(--tw-bg-opacity)) !important;
}

.active\\:bg-transparent:active {
  background-color: transparent !important;
}

.active\\:bg-none:active {
  background-image: none !important;
}

.active\\:text-gray-50:active {
  color: var(--gray-50) !important;
}

.active\\:opacity-100:active {
  opacity: 1 !important;
}

.active\\:shadow-none:active {
  --tw-shadow: 0 0 rgba(0,0,0,0) !important;
  --tw-shadow-colored: 0 0 rgba(0,0,0,0) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}

.active\\:after\\:opacity-0:active::after {
  content: var(--tw-content) !important;
  opacity: 0 !important;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed !important;
}

.disabled\\:border-0:disabled {
  border-width: 0px !important;
}

.disabled\\:border-red-800:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgba(153, 27, 27, 1) !important;
  border-color: rgba(153, 27, 27, var(--tw-border-opacity)) !important;
}

.disabled\\:border-teal-400:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgba(45, 212, 191, 1) !important;
  border-color: rgba(45, 212, 191, var(--tw-border-opacity)) !important;
}

.disabled\\:bg-gray-50:disabled {
  background-color: var(--gray-50) !important;
}

.disabled\\:bg-gray-500:disabled {
  background-color: var(--gray-500) !important;
}

.disabled\\:bg-gray-600:disabled {
  background-color: var(--gray-600) !important;
}

.disabled\\:bg-gray-700:disabled {
  background-color: var(--gray-700) !important;
}

.disabled\\:bg-gray-800:disabled {
  background-color: var(--gray-800) !important;
}

.disabled\\:bg-transparent:disabled {
  background-color: transparent !important;
}

.disabled\\:text-gray-300:disabled {
  color: var(--gray-300) !important;
}

.disabled\\:text-gray-400:disabled {
  color: var(--gray-400) !important;
}

.disabled\\:text-gray-50:disabled {
  color: var(--gray-50) !important;
}

.disabled\\:text-gray-50-alpha\\/50:disabled {
  color: rgba(var(--gray-50-rgb), 0.5) !important;
}

.disabled\\:text-gray-500:disabled {
  color: var(--gray-500) !important;
}

.disabled\\:text-gray-950:disabled {
  color: var(--gray-950) !important;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5 !important;
}

.disabled\\:opacity-80:disabled {
  opacity: 0.8 !important;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 rgba(0,0,0,0) !important;
  --tw-shadow-colored: 0 0 rgba(0,0,0,0) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}

.disabled\\:after\\:border-gray-50:disabled::after {
  content: var(--tw-content) !important;
  border-color: var(--gray-50) !important;
}

.disabled\\:after\\:border-gray-500:disabled::after {
  content: var(--tw-content) !important;
  border-color: var(--gray-500) !important;
}

.disabled\\:after\\:opacity-0:disabled::after {
  content: var(--tw-content) !important;
  opacity: 0 !important;
}

.disabled\\:after\\:opacity-100:disabled::after {
  content: var(--tw-content) !important;
  opacity: 1 !important;
}

.disabled\\:hover\\:border-red-800:hover:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgba(153, 27, 27, 1) !important;
  border-color: rgba(153, 27, 27, var(--tw-border-opacity)) !important;
}

.disabled\\:hover\\:bg-gray-400:hover:disabled {
  background-color: var(--gray-400) !important;
}

.disabled\\:hover\\:bg-gray-50:hover:disabled {
  background-color: var(--gray-50) !important;
}

.disabled\\:hover\\:bg-gray-500:hover:disabled {
  background-color: var(--gray-500) !important;
}

.disabled\\:hover\\:bg-gray-600:hover:disabled {
  background-color: var(--gray-600) !important;
}

.disabled\\:hover\\:bg-gray-700:hover:disabled {
  background-color: var(--gray-700) !important;
}

.disabled\\:hover\\:bg-gray-800:hover:disabled {
  background-color: var(--gray-800) !important;
}

.disabled\\:active\\:bg-brand-mixed-gradient:active:disabled {
  background-image: linear-gradient(to right, var(--brand-purple), var(--brand-pink)) !important;
}

@container (min-width: 12rem) {

  .\\@3xs\\:scale-\\[0\\.3\\] {
    --tw-scale-x: 0.3 !important;
    --tw-scale-y: 0.3 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.3) scaleY(0.3) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 16rem) {

  .\\@2xs\\:scale-\\[0\\.4\\] {
    --tw-scale-x: 0.4 !important;
    --tw-scale-y: 0.4 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.4) scaleY(0.4) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 24rem) {

  .\\@sm\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
}

@container table (min-width: 28rem) {

  .\\@md\\/table\\:static {
    position: static !important;
  }

  .\\@md\\/table\\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }

  .\\@md\\/table\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .\\@md\\/table\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .\\@md\\/table\\:col-span-4 {
    grid-column: span 4 / span 4 !important;
  }

  .\\@md\\/table\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .\\@md\\/table\\:col-span-6 {
    grid-column: span 6 / span 6 !important;
  }

  .\\@md\\/table\\:col-span-7 {
    grid-column: span 7 / span 7 !important;
  }

  .\\@md\\/table\\:flex {
    display: flex !important;
  }

  .\\@md\\/table\\:hidden {
    display: none !important;
  }

  .\\@md\\/table\\:grid-cols-\\[auto_1fr_1fr_1fr\\] {
    grid-template-columns: auto 1fr 1fr 1fr !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(1\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(1,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(2\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(2,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(3\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(3,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(4\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(4,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(5\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(5,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(6\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(6,minmax(auto,1fr)) !important;
  }

  .\\@md\\/table\\:grid-cols-\\[repeat\\(7\\2c minmax\\(auto\\2c 1fr\\)\\)\\] {
    grid-template-columns: repeat(7,minmax(auto,1fr)) !important;
  }
}

@container (min-width: 28rem) {

  .\\@md\\:scale-\\[0\\.5\\] {
    --tw-scale-x: 0.5 !important;
    --tw-scale-y: 0.5 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.5) scaleY(0.5) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 32rem) {

  .\\@lg\\:scale-\\[0\\.5\\] {
    --tw-scale-x: 0.5 !important;
    --tw-scale-y: 0.5 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.5) scaleY(0.5) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 36rem) {

  .\\@xl\\:scale-\\[0\\.6\\] {
    --tw-scale-x: 0.6 !important;
    --tw-scale-y: 0.6 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.6) scaleY(0.6) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 42rem) {

  .\\@2xl\\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }

  .\\@2xl\\:scale-\\[0\\.7\\] {
    --tw-scale-x: 0.7 !important;
    --tw-scale-y: 0.7 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.7) scaleY(0.7) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 48rem) {

  .\\@3xl\\:scale-\\[0\\.8\\] {
    --tw-scale-x: 0.8 !important;
    --tw-scale-y: 0.8 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.8) scaleY(0.8) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 56rem) {

  .\\@4xl\\:scale-\\[0\\.9\\] {
    --tw-scale-x: 0.9 !important;
    --tw-scale-y: 0.9 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.9) scaleY(0.9) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@container (min-width: 64rem) {

  .\\@5xl\\:scale-\\[1\\] {
    --tw-scale-x: 1 !important;
    --tw-scale-y: 1 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@media not all and (min-width: 768px) {

  .max-md\\:static {
    position: static !important;
  }

  .max-md\\:relative {
    position: relative !important;
  }

  .max-md\\:-order-1 {
    order: -1 !important;
  }

  .max-md\\:m-0 {
    margin: 0px !important;
  }

  .max-md\\:ml-0 {
    margin-left: 0px !important;
  }

  .max-md\\:block {
    display: block !important;
  }

  .max-md\\:flex {
    display: flex !important;
  }

  .max-md\\:hidden {
    display: none !important;
  }

  .max-md\\:aspect-auto {
    aspect-ratio: auto !important;
  }

  .max-md\\:h-\\[50vw\\] {
    height: 50vw !important;
  }

  .max-md\\:h-auto {
    height: auto !important;
  }

  .max-md\\:w-full {
    width: 100% !important;
  }

  .max-md\\:flex-col {
    flex-direction: column !important;
  }

  .max-md\\:overflow-hidden {
    overflow: hidden !important;
  }

  .max-md\\:overflow-y-visible {
    overflow-y: visible !important;
  }

  .max-md\\:rounded-none {
    border-radius: 0px !important;
  }

  .max-md\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }

  .max-md\\:rounded-t-none {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  .max-md\\:py-\\[2px\\] {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .max-md\\:pb-0 {
    padding-bottom: 0px !important;
  }

  .max-md\\:pl-0 {
    padding-left: 0px !important;
  }

  .max-md\\:pt-0 {
    padding-top: 0px !important;
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:mx-3 {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }

  .max-sm\\:mb-20 {
    margin-bottom: 80px !important;
  }

  .max-sm\\:mb-8 {
    margin-bottom: 32px !important;
  }

  .max-sm\\:block {
    display: block !important;
  }

  .max-sm\\:flex {
    display: flex !important;
  }

  .max-sm\\:hidden {
    display: none !important;
  }

  .max-sm\\:text-xxs {
    font-size: 0.5rem !important;
  }

  .max-sm\\:first\\:table-cell:first-child {
    display: table-cell !important;
  }

  .max-sm\\:last\\:table-cell:last-child {
    display: table-cell !important;
  }
}

@media (min-width: 640px) {

  .sm\\:-right-5\\.5 {
    right: -22px !important;
  }

  .sm\\:-top-16 {
    top: -64px !important;
  }

  .sm\\:left-0 {
    left: 0px !important;
  }

  .sm\\:top-44 {
    top: 11rem !important;
  }

  .sm\\:my-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  .sm\\:my-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }

  .sm\\:-mb-28 {
    margin-bottom: -112px !important;
  }

  .sm\\:ml-5 {
    margin-left: 20px !important;
  }

  .sm\\:mr-3 {
    margin-right: 12px !important;
  }

  .sm\\:mt-12 {
    margin-top: 48px !important;
  }

  .sm\\:mt-8 {
    margin-top: 32px !important;
  }

  .sm\\:block {
    display: block !important;
  }

  .sm\\:flex {
    display: flex !important;
  }

  .sm\\:hidden {
    display: none !important;
  }

  .sm\\:h-\\[20px\\] {
    height: 20px !important;
  }

  .sm\\:h-auto {
    height: auto !important;
  }

  .sm\\:w-\\[160px\\] {
    width: 160px !important;
  }

  .sm\\:w-\\[180px\\] {
    width: 180px !important;
  }

  .sm\\:w-\\[20px\\] {
    width: 20px !important;
  }

  .sm\\:w-\\[300px\\] {
    width: 300px !important;
  }

  .sm\\:w-\\[40px\\] {
    width: 40px !important;
  }

  .sm\\:w-\\[calc\\(33\\.33\\%-8px\\)\\] {
    width: calc(33.33% - 8px) !important;
  }

  .sm\\:w-full {
    width: 100% !important;
  }

  .sm\\:min-w-full {
    min-width: 100% !important;
  }

  .sm\\:max-w-\\[320px\\] {
    max-width: 320px !important;
  }

  .sm\\:max-w-\\[360px\\] {
    max-width: 360px !important;
  }

  .sm\\:max-w-\\[400px\\] {
    max-width: 400px !important;
  }

  .sm\\:max-w-\\[420px\\] {
    max-width: 420px !important;
  }

  .sm\\:max-w-\\[450px\\] {
    max-width: 450px !important;
  }

  .sm\\:max-w-\\[460px\\] {
    max-width: 460px !important;
  }

  .sm\\:max-w-\\[500px\\] {
    max-width: 500px !important;
  }

  .sm\\:max-w-\\[520px\\] {
    max-width: 520px !important;
  }

  .sm\\:max-w-\\[580px\\] {
    max-width: 580px !important;
  }

  .sm\\:max-w-\\[600px\\] {
    max-width: 600px !important;
  }

  .sm\\:translate-y-0 {
    --tw-translate-y: 0px !important;
    transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }

  .sm\\:scale-100 {
    --tw-scale-x: 1 !important;
    --tw-scale-y: 1 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }

  .sm\\:scale-95 {
    --tw-scale-x: .95 !important;
    --tw-scale-y: .95 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:flex-row {
    flex-direction: row !important;
  }

  .sm\\:items-center {
    align-items: center !important;
  }

  .sm\\:gap-5 {
    gap: 20px !important;
  }

  .sm\\:gap-x-3 {
    -moz-column-gap: 12px !important;
         column-gap: 12px !important;
  }

  .sm\\:-space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(-4px * 0) !important;
    margin-right: calc(-4px * var(--tw-space-x-reverse)) !important;
    margin-left: calc(-4px * (1 - 0)) !important;
    margin-left: calc(-4px * (1 - var(--tw-space-x-reverse))) !important;
    margin-left: calc(-4px * calc(1 - 0)) !important;
    margin-left: calc(-4px * calc(1 - var(--tw-space-x-reverse))) !important;
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem !important;
  }

  .sm\\:rounded-s-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
  }

  .sm\\:p-0 {
    padding: 0px !important;
  }

  .sm\\:p-3 {
    padding: 12px !important;
  }

  .sm\\:p-4 {
    padding: 16px !important;
  }

  .sm\\:p-5 {
    padding: 20px !important;
  }

  .sm\\:p-6 {
    padding: 24px !important;
  }

  .sm\\:px-2 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .sm\\:px-3 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .sm\\:px-4 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .sm\\:px-6 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .sm\\:py-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px !important;
  }

  .sm\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .sm\\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem !important;
  }

  .sm\\:first\\:table-cell:first-child {
    display: table-cell !important;
  }

  .sm\\:last\\:table-cell:last-child {
    display: table-cell !important;
  }
}

@media (min-width: 768px) {

  .md\\:fixed {
    position: fixed !important;
  }

  .md\\:inset-y-0 {
    top: 0px !important;
    bottom: 0px !important;
  }

  .md\\:bottom-0 {
    bottom: 0px !important;
  }

  .md\\:bottom-10 {
    bottom: 40px !important;
  }

  .md\\:bottom-20 {
    bottom: 80px !important;
  }

  .md\\:bottom-4 {
    bottom: 16px !important;
  }

  .md\\:bottom-5 {
    bottom: 20px !important;
  }

  .md\\:bottom-\\[50\\%\\] {
    bottom: 50% !important;
  }

  .md\\:bottom-\\[92px\\] {
    bottom: 92px !important;
  }

  .md\\:left-4 {
    left: 16px !important;
  }

  .md\\:left-5 {
    left: 20px !important;
  }

  .md\\:left-auto {
    left: auto !important;
  }

  .md\\:right-0 {
    right: 0px !important;
  }

  .md\\:right-4 {
    right: 16px !important;
  }

  .md\\:right-5 {
    right: 20px !important;
  }

  .md\\:top-4 {
    top: 16px !important;
  }

  .md\\:top-5 {
    top: 20px !important;
  }

  .md\\:z-30 {
    z-index: 30 !important;
  }

  .md\\:-mt-1 {
    margin-top: -4px !important;
  }

  .md\\:ml-0 {
    margin-left: 0px !important;
  }

  .md\\:mt-0 {
    margin-top: 0px !important;
  }

  .md\\:mt-0\\.5 {
    margin-top: 2px !important;
  }

  .md\\:block {
    display: block !important;
  }

  .md\\:inline {
    display: inline !important;
  }

  .md\\:flex {
    display: flex !important;
  }

  .md\\:hidden {
    display: none !important;
  }

  .md\\:aspect-auto {
    aspect-ratio: auto !important;
  }

  .md\\:aspect-square {
    aspect-ratio: 1 / 1 !important;
  }

  .md\\:aspect-video {
    aspect-ratio: 16 / 9 !important;
  }

  .md\\:h-\\[218px\\] {
    height: 218px !important;
  }

  .md\\:h-\\[360px\\] {
    height: 360px !important;
  }

  .md\\:h-\\[380px\\] {
    height: 380px !important;
  }

  .md\\:h-\\[44px\\] {
    height: 44px !important;
  }

  .md\\:h-\\[60px\\] {
    height: 60px !important;
  }

  .md\\:h-\\[calc\\(100\\%-var\\(--game-frame-tool-bar-height\\)\\)\\] {
    height: calc(100% - var(--game-frame-tool-bar-height)) !important;
  }

  .md\\:h-full {
    height: 100% !important;
  }

  .md\\:h-screen {
    height: 100vh !important;
  }

  .md\\:h-screen-minus-bar {
    height: calc(100vh - var(--top-bar-height)) !important;
  }

  .md\\:max-h-\\[calc\\(100\\%-var\\(--game-frame-tool-bar-height\\)\\)\\] {
    max-height: calc(100% - var(--game-frame-tool-bar-height)) !important;
  }

  .md\\:max-h-screen {
    max-height: 100vh !important;
  }

  .md\\:w-1\\/2 {
    width: 50% !important;
  }

  .md\\:w-80 {
    width: 320px !important;
  }

  .md\\:w-\\[18px\\] {
    width: 18px !important;
  }

  .md\\:w-\\[20\\%\\] {
    width: 20% !important;
  }

  .md\\:w-\\[360px\\] {
    width: 360px !important;
  }

  .md\\:w-\\[460px\\] {
    width: 460px !important;
  }

  .md\\:w-\\[520px\\] {
    width: 520px !important;
  }

  .md\\:w-\\[560px\\] {
    width: 560px !important;
  }

  .md\\:w-\\[60px\\] {
    width: 60px !important;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80% !important;
  }

  .md\\:w-\\[800px\\] {
    width: 800px !important;
  }

  .md\\:w-\\[calc\\(100\\%_-_var\\(--side-bar-width\\)\\)\\] {
    width: calc(100% - var(--side-bar-width)) !important;
  }

  .md\\:w-\\[calc\\(25\\%-9px\\)\\] {
    width: calc(25% - 9px) !important;
  }

  .md\\:w-\\[calc\\(33\\.33\\%-16px\\)\\] {
    width: calc(33.33% - 16px) !important;
  }

  .md\\:w-\\[calc\\(50\\%-6px\\)\\] {
    width: calc(50% - 6px) !important;
  }

  .md\\:w-auto {
    width: auto !important;
  }

  .md\\:max-w-\\[550px\\] {
    max-width: 550px !important;
  }

  .md\\:grow {
    flex-grow: 1 !important;
  }

  .md\\:flex-row {
    flex-direction: row !important;
  }

  .md\\:flex-col {
    flex-direction: column !important;
  }

  .md\\:items-start {
    align-items: flex-start !important;
  }

  .md\\:justify-center {
    justify-content: center !important;
  }

  .md\\:gap-0 {
    gap: 0px !important;
  }

  .md\\:gap-2 {
    gap: 8px !important;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem !important;
  }

  .md\\:bg-transparent {
    background-color: transparent !important;
  }

  .md\\:p-3 {
    padding: 12px !important;
  }

  .md\\:px-1\\.5 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .md\\:px-10 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }

  .md\\:px-14 {
    padding-left: 56px !important;
    padding-right: 56px !important;
  }

  .md\\:px-6 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .md\\:py-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .md\\:pb-5 {
    padding-bottom: 20px !important;
  }

  .md\\:pb-\\[155px\\] {
    padding-bottom: 155px !important;
  }

  .md\\:pb-\\[52px\\] {
    padding-bottom: 52px !important;
  }

  .md\\:pb-\\[76px\\] {
    padding-bottom: 76px !important;
  }

  .md\\:pl-0 {
    padding-left: 0px !important;
  }

  .md\\:pl-left-bar-width {
    padding-left: var(--side-bar-width) !important;
  }

  .md\\:pr-0 {
    padding-right: 0px !important;
  }

  .md\\:pr-right-bar-width {
    padding-right: var(--side-bar-width) !important;
  }

  .md\\:pt-0 {
    padding-top: 0px !important;
  }

  .md\\:pt-5 {
    padding-top: 20px !important;
  }

  .md\\:pt-\\[40px\\] {
    padding-top: 40px !important;
  }

  .md\\:text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px !important;
  }

  .md\\:text-\\[30px\\] {
    font-size: 30px !important;
  }

  .md\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .md\\:hover\\:-translate-y-3:hover {
    --tw-translate-y: -12px !important;
    transform: translate(var(--tw-translate-x), -12px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@media (min-width: 1024px) {

  .lg\\:bottom-4\\.5 {
    bottom: 18px !important;
  }

  .lg\\:mb-8 {
    margin-bottom: 32px !important;
  }

  .lg\\:mr-4 {
    margin-right: 16px !important;
  }

  .lg\\:flex {
    display: flex !important;
  }

  .lg\\:table-cell {
    display: table-cell !important;
  }

  .lg\\:hidden {
    display: none !important;
  }

  .lg\\:h-\\[30px\\] {
    height: 30px !important;
  }

  .lg\\:w-3\\/4 {
    width: 75% !important;
  }

  .lg\\:w-\\[30px\\] {
    width: 30px !important;
  }

  .lg\\:w-\\[62px\\] {
    width: 62px !important;
  }

  .lg\\:w-\\[calc\\(20\\%-6\\.9px\\)\\] {
    width: calc(20% - 6.9px) !important;
  }

  .lg\\:w-\\[calc\\(25\\%-16px\\)\\] {
    width: calc(25% - 16px) !important;
  }

  .lg\\:w-\\[calc\\(33\\.33\\%-8px\\)\\] {
    width: calc(33.33% - 8px) !important;
  }

  .lg\\:p-4 {
    padding: 16px !important;
  }

  .lg\\:px-3 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .lg\\:px-6 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .lg\\:py-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .lg\\:pr-\\[280px\\] {
    padding-right: 280px !important;
  }

  .lg\\:text-\\[30px\\] {
    font-size: 30px !important;
  }

  .lg\\:text-\\[90px\\] {
    font-size: 90px !important;
  }
}

@media (min-width: 1280px) {

  .xl\\:h-\\[40px\\] {
    height: 40px !important;
  }

  .xl\\:h-\\[45px\\] {
    height: 45px !important;
  }

  .xl\\:w-\\[45px\\] {
    width: 45px !important;
  }

  .xl\\:w-\\[calc\\(16\\.67\\%-10px\\)\\] {
    width: calc(16.67% - 10px) !important;
  }

  .xl\\:gap-3 {
    gap: 12px !important;
  }
}

.\\[\\&\\.start\\]\\:justify-start.start {
  justify-content: flex-start !important;
}

.\\[\\&\\:active\\]\\:bg-gray-600:active {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\:active\\]\\:bg-white\\/10:active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.\\[\\&\\:first-child\\]\\:rounded-l-md:first-child {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.\\[\\&\\:hover\\>\\*\\:last-child\\]\\:block:hover>*:last-child {
  display: block !important;
}

.\\[\\&\\:hover\\>div\\>div\\>div\\>span\\]\\:text-gray-50:hover>div>div>div>span {
  color: var(--gray-50) !important;
}

.\\[\\&\\:hover\\>td\\>div\\]\\:bg-gray-600:hover>td>div {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\:hover\\]\\:bg-gray-500:hover {
  background-color: var(--gray-500) !important;
}

.\\[\\&\\:hover\\]\\:bg-gray-600:hover {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\:hover\\]\\:bg-gray-800:hover {
  background-color: var(--gray-800) !important;
}

.\\[\\&\\:hover\\]\\:scrollbar-thumb-gray-900:hover {
  --scrollbar-thumb: var(--gray-900) !important;
}

.\\[\\&\\:last-child\\]\\:rounded-r-md:last-child {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.\\[\\&\\:not\\(\\.expanded\\)\\]\\:\\!max-h-\\[760px\\]:not(.expanded) {
  max-height: 760px !important;
}

.\\[\\&\\:not\\(\\.expanded\\)\\]\\:w-full:not(.expanded) {
  width: 100% !important;
}

@container (min-width: 20rem) {

  .\\@xs\\:\\[\\&\\:not\\(\\.expanded\\)\\]\\:\\!aspect-\\[3\\/7\\]:not(.expanded) {
    aspect-ratio: 3/7 !important;
  }
}

@container (min-width: 48rem) {

  .\\@3xl\\:\\[\\&\\:not\\(\\.expanded\\)\\]\\:\\!aspect-\\[4\\/3\\]:not(.expanded) {
    aspect-ratio: 4/3 !important;
  }
}

@container (min-width: 64rem) {

  .\\@5xl\\:\\[\\&\\:not\\(\\.expanded\\)\\]\\:aspect-video:not(.expanded) {
    aspect-ratio: 16 / 9 !important;
  }
}

@media (min-width: 640px) {

  .sm\\:\\[\\&\\:nth-child\\(2\\)\\]\\:table-cell:nth-child(2) {
    display: table-cell !important;
  }
}

.\\[\\&\\:nth-child\\(2n\\+3\\)\\]\\:bg-gray-700:nth-child(2n+3) {
  background-color: var(--gray-700) !important;
}

@media (min-width: 768px) {

  .md\\:\\[\\&\\:nth-child\\(3\\)\\]\\:table-cell:nth-child(3) {
    display: table-cell !important;
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:\\[\\&\\:nth-child\\(5\\)\\]\\:table-cell:nth-child(5) {
    display: table-cell !important;
  }
}

@media (min-width: 640px) {

  .sm\\:\\[\\&\\:nth-child\\(5\\)\\]\\:table-cell:nth-child(5) {
    display: table-cell !important;
  }
}

.\\[\\&\\:nth-child\\(even\\)\\]\\:bg-gray-700:nth-child(even) {
  background-color: var(--gray-700) !important;
}

.\\[\\&\\>\\#tsparticles\\]\\:h-full>#tsparticles {
  height: 100% !important;
}

.\\[\\&\\>\\*\\:last-child\\]\\:hidden>*:last-child {
  display: none !important;
}

.\\[\\&\\>\\*\\>\\*\\>\\*\\>\\*\\>\\*\\]\\:text-lg>*>*>*>*>* {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}

.\\[\\&\\>\\*\\>\\*\\>\\*\\>\\*\\>\\*\\]\\:font-semibold>*>*>*>*>* {
  font-weight: 600 !important;
}

.\\[\\&\\>\\*\\>\\*\\>\\*\\]\\:pb-2>*>*>* {
  padding-bottom: 8px !important;
}

.\\[\\&\\>\\*\\>\\*\\]\\:text-lg>*>* {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}

.\\[\\&\\>\\*\\>\\*\\]\\:font-semibold>*>* {
  font-weight: 600 !important;
}

.\\[\\&\\>\\*\\>\\*\\]\\:text-gray-900>*>* {
  color: var(--gray-900) !important;
}

.\\[\\&\\>\\*\\>\\.trigger-button-icon\\]\\:flex>*>.trigger-button-icon {
  display: flex !important;
}

.\\[\\&\\>\\*\\>button\\.active\\]\\:bg-brand-pink-normal>*>button.active {
  background-color: var(--brand-pink) !important;
}

.\\[\\&\\>\\*\\>button\\]\\:h-9>*>button {
  height: 36px !important;
}

.\\[\\&\\>\\*\\>button\\]\\:min-w-9>*>button {
  min-width: 36px !important;
}

.\\[\\&\\>\\*\\>button\\]\\:items-center>*>button {
  align-items: center !important;
}

.\\[\\&\\>\\*\\>button\\]\\:justify-center>*>button {
  justify-content: center !important;
}

.\\[\\&\\>\\*\\>button\\]\\:whitespace-nowrap>*>button {
  white-space: nowrap !important;
}

.\\[\\&\\>\\*\\>button\\]\\:rounded-md>*>button {
  border-radius: 0.375rem !important;
}

.\\[\\&\\>\\*\\>button\\]\\:bg-gray-700>*>button {
  background-color: var(--gray-700) !important;
}

.\\[\\&\\>\\*\\>button\\]\\:px-2>*>button {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.\\[\\&\\>\\*\\>button\\]\\:py-\\[15px\\]>*>button {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.\\[\\&\\>\\*\\>button\\]\\:text-sm>*>button {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.\\[\\&\\>\\*\\>button\\]\\:font-normal>*>button {
  font-weight: 400 !important;
}

.\\[\\&\\>\\*\\>li\\]\\:pb-1>*>li {
  padding-bottom: 4px !important;
}

.\\[\\&\\>\\*\\]\\:h-full>* {
  height: 100% !important;
}

.\\[\\&\\>\\*\\]\\:w-full>* {
  width: 100% !important;
}

.\\[\\&\\>\\*\\]\\:grow>* {
  flex-grow: 1 !important;
}

.\\[\\&\\>\\*\\]\\:flex-wrap>* {
  flex-wrap: wrap !important;
}

.\\[\\&\\>\\*\\]\\:gap-2>* {
  gap: 8px !important;
}

.\\[\\&\\>\\*\\]\\:opacity-0>* {
  opacity: 0 !important;
}

.\\[\\&\\>\\.gameBoard\\]\\:overflow-visible>.gameBoard {
  overflow: visible !important;
}

.\\[\\&\\>\\.gray-button\\]\\:bg-gray-500>.gray-button {
  background-color: var(--gray-500) !important;
}

.\\[\\&\\>\\.os-scrollbar-vertical\\]\\:right-4\\.5>.os-scrollbar-vertical {
  right: 18px !important;
}

.\\[\\&\\>\\.swiper-pagination\\>\\.swiper-pagination-bullet-active\\]\\:bg-gray-50>.swiper-pagination>.swiper-pagination-bullet-active {
  background-color: var(--gray-50) !important;
}

.\\[\\&\\>\\.swiper-pagination\\>\\.swiper-pagination-bullet\\]\\:mx-2>.swiper-pagination>.swiper-pagination-bullet {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.\\[\\&\\>\\.swiper-pagination\\>\\.swiper-pagination-bullet\\]\\:h-2>.swiper-pagination>.swiper-pagination-bullet {
  height: 8px !important;
}

.\\[\\&\\>\\.swiper-pagination\\>\\.swiper-pagination-bullet\\]\\:w-2>.swiper-pagination>.swiper-pagination-bullet {
  width: 8px !important;
}

.\\[\\&\\>\\.swiper-pagination\\>\\.swiper-pagination-bullet\\]\\:bg-gray-100>.swiper-pagination>.swiper-pagination-bullet {
  background-color: var(--gray-100) !important;
}

.\\[\\&\\>\\.swiper-pagination\\]\\:absolute>.swiper-pagination {
  position: absolute !important;
}

.\\[\\&\\>\\.swiper-pagination\\]\\:-bottom-1>.swiper-pagination {
  bottom: -4px !important;
}

.\\[\\&\\>\\.tippy-arrow\\]\\:text-\\[var\\(--gray-500\\)\\]>.tippy-arrow {
  color: var(--gray-500) !important;
}

.\\[\\&\\>\\.tippy-arrow\\]\\:text-\\[var\\(--purple-500\\)\\]>.tippy-arrow {
  color: var(--purple-500) !important;
}

.\\[\\&\\>\\.tippy-arrow\\]\\:text-gray-500>.tippy-arrow {
  color: var(--gray-500) !important;
}

.\\[\\&\\>\\.tippy-arrow\\]\\:text-gray-700>.tippy-arrow {
  color: var(--gray-700) !important;
}

.\\[\\&\\>\\.tippy-arrow\\]\\:text-green-700>.tippy-arrow {
  --tw-text-opacity: 1 !important;
  color: rgba(21, 128, 61, 1) !important;
  color: rgba(21, 128, 61, var(--tw-text-opacity)) !important;
}

.\\[\\&\\>\\.tippy-content\\]\\:bg-\\[var\\(--gray-500\\)\\]>.tippy-content {
  background-color: var(--gray-500) !important;
}

.\\[\\&\\>\\.tippy-content\\]\\:bg-\\[var\\(--purple-500\\)\\]>.tippy-content {
  background-color: var(--purple-500) !important;
}

.\\[\\&\\>\\.tippy-content\\]\\:p-0>.tippy-content {
  padding: 0px !important;
}

.\\[\\&\\>aside\\>div\\>div\\]\\:bg-gray-600>aside>div>div {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\>aside\\]\\:z-20>aside {
  z-index: 20 !important;
}

.\\[\\&\\>aside\\]\\:hidden>aside {
  display: none !important;
}

@media (min-width: 768px) {

  .md\\:\\[\\&\\>aside\\]\\:left-1\\/2>aside {
    left: 50% !important;
  }

  .md\\:\\[\\&\\>aside\\]\\:left-\\[calc\\(50\\%-140px\\)\\]>aside {
    left: calc(50% - 140px) !important;
  }

  .md\\:\\[\\&\\>aside\\]\\:w-1\\/2>aside {
    width: 50% !important;
  }

  .md\\:\\[\\&\\>aside\\]\\:w-\\[300px\\]>aside {
    width: 300px !important;
  }

  .md\\:\\[\\&\\>aside\\]\\:-translate-x-1\\/2>aside {
    --tw-translate-x: -50% !important;
    transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

.\\[\\&\\>button\\>\\*\\>\\*\\]\\:text-gray-300>button>*>* {
  color: var(--gray-300) !important;
}

.\\[\\&\\>button\\]\\:mb-2>button {
  margin-bottom: 8px !important;
}

.\\[\\&\\>button\\]\\:w-1\\/2>button {
  width: 50% !important;
}

.\\[\\&\\>button\\]\\:w-11>button {
  width: 2.75rem !important;
}

.\\[\\&\\>button\\]\\:w-full>button {
  width: 100% !important;
}

.\\[\\&\\>button\\]\\:bg-gray-500>button {
  background-color: var(--gray-500) !important;
}

.disabled\\:\\[\\&\\>button\\]\\:bg-gray-600>button:disabled {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\>canvas\\]\\:absolute>canvas {
  position: absolute !important;
}

.\\[\\&\\>canvas\\]\\:relative>canvas {
  position: relative !important;
}

.\\[\\&\\>canvas\\]\\:z-20>canvas {
  z-index: 20 !important;
}

.\\[\\&\\>canvas\\]\\:z-\\[29\\]>canvas {
  z-index: 29 !important;
}

.\\[\\&\\>div\\>\\*\\]\\:translate-x-0>div>* {
  --tw-translate-x: 0px !important;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>div\\>\\*\\]\\:translate-y-0>div>* {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>div\\>\\.close-button\\>div\\]\\:text-\\[22px\\]>div>.close-button>div {
  font-size: 22px !important;
}

.\\[\\&\\>div\\>\\.close-button\\]\\:absolute>div>.close-button {
  position: absolute !important;
}

.\\[\\&\\>div\\>\\.close-button\\]\\:right-4>div>.close-button {
  right: 16px !important;
}

.\\[\\&\\>div\\>\\.close-button\\]\\:top-4\\.5>div>.close-button {
  top: 18px !important;
}

.\\[\\&\\>div\\>\\.close-button\\]\\:z-50>div>.close-button {
  z-index: 50 !important;
}

.\\[\\&\\>div\\>\\.label\\]\\:text-gray-200>div>.label {
  color: var(--gray-200) !important;
}

.\\[\\&\\>div\\>div\\]\\:flex-1>div>div {
  flex: 1 1 0% !important;
}

.\\[\\&\\>div\\>div\\]\\:self-start>div>div {
  align-self: flex-start !important;
}

.\\[\\&\\>div\\>div\\]\\:first\\:justify-start:first-child>div>div {
  justify-content: flex-start !important;
}

.\\[\\&\\>div\\>div\\]\\:last\\:justify-end:last-child>div>div {
  justify-content: flex-end !important;
}

.\\[\\&\\>div\\>img\\]\\:mt-0>div>img {
  margin-top: 0px !important;
}

.\\[\\&\\>div\\>img\\]\\:w-7>div>img {
  width: 28px !important;
}

.\\[\\&\\>div\\>img\\]\\:transition-all>div>img {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}

.\\[\\&\\>div\\>img\\]\\:duration-500>div>img {
  transition-duration: 500ms !important;
}

.\\[\\&\\>div\\]\\:visible>div {
  visibility: visible !important;
}

.\\[\\&\\>div\\]\\:bottom-3>div {
  bottom: 12px !important;
}

.\\[\\&\\>div\\]\\:flex>div {
  display: flex !important;
}

.\\[\\&\\>div\\]\\:w-full>div {
  width: 100% !important;
}

.\\[\\&\\>div\\]\\:flex-1>div {
  flex: 1 1 0% !important;
}

.\\[\\&\\>div\\]\\:items-center>div {
  align-items: center !important;
}

.\\[\\&\\>div\\]\\:justify-center>div {
  justify-content: center !important;
}

.\\[\\&\\>div\\]\\:rounded-lg>div {
  border-radius: 0.5rem !important;
}

.\\[\\&\\>div\\]\\:rounded-md>div {
  border-radius: 0.375rem !important;
}

.\\[\\&\\>div\\]\\:bg-gray-50>div {
  background-color: var(--gray-50) !important;
}

.\\[\\&\\>div\\]\\:bg-gray-600>div {
  background-color: var(--gray-600) !important;
}

.\\[\\&\\>div\\]\\:p-3>div {
  padding: 12px !important;
}

.\\[\\&\\>div\\]\\:py-2>div {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.\\[\\&\\>div\\]\\:pb-0>div {
  padding-bottom: 0px !important;
}

.\\[\\&\\>div\\]\\:text-gray-50>div {
  color: var(--gray-50) !important;
}

.\\[\\&\\>div\\]\\:first\\:justify-start:first-child>div {
  justify-content: flex-start !important;
}

.\\[\\&\\>div\\]\\:last\\:justify-end:last-child>div {
  justify-content: flex-end !important;
}

.\\[\\&\\>div\\]\\:hover\\:visible:hover>div {
  visibility: visible !important;
}

.\\[\\&\\>img\\]\\:h-full>img {
  height: 100% !important;
}

.\\[\\&\\>img\\]\\:w-full>img {
  width: 100% !important;
}

.\\[\\&\\>img\\]\\:rounded-full>img {
  border-radius: 9999px !important;
}

.\\[\\&\\>label\\]\\:text-base>label {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}

.\\[\\&\\>label\\]\\:font-normal>label {
  font-weight: 400 !important;
}

.\\[\\&\\>label\\]\\:font-semibold>label {
  font-weight: 600 !important;
}

.\\[\\&\\>label\\]\\:text-gray-200>label {
  color: var(--gray-200) !important;
}

.\\[\\&\\>ol\\]\\:list-inside>ol {
  list-style-position: inside !important;
}

.\\[\\&\\>ol\\]\\:list-decimal>ol {
  list-style-type: decimal !important;
}

.\\[\\&\\>path\\]\\:fill-gray-50>path {
  fill: var(--gray-50) !important;
}

.\\[\\&\\>svg\\>\\*\\]\\:h-full>svg>* {
  height: 100% !important;
}

.\\[\\&\\>svg\\>\\*\\]\\:w-full>svg>* {
  width: 100% !important;
}

.\\[\\&\\>svg\\>path\\]\\:h-full>svg>path {
  height: 100% !important;
}

.\\[\\&\\>svg\\>path\\]\\:w-full>svg>path {
  width: 100% !important;
}

.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute !important;
}

.\\[\\&\\>svg\\]\\:left-\\[50\\%\\]>svg {
  left: 50% !important;
}

.\\[\\&\\>svg\\]\\:h-4\\.5>svg {
  height: 18px !important;
}

.\\[\\&\\>svg\\]\\:h-full>svg {
  height: 100% !important;
}

.\\[\\&\\>svg\\]\\:max-h-full>svg {
  max-height: 100% !important;
}

.\\[\\&\\>svg\\]\\:w-full>svg {
  width: 100% !important;
}

.\\[\\&\\>svg\\]\\:max-w-full>svg {
  max-width: 100% !important;
}

.\\[\\&\\>svg\\]\\:translate-x-\\[-50\\%\\]>svg {
  --tw-translate-x: -50% !important;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>svg\\]\\:fill-current>svg {
  fill: currentColor !important;
}

.\\[\\&\\>svg\\]\\:stroke-current>svg {
  stroke: currentColor !important;
}

.\\[\\&\\>svg\\]\\:stroke-2>svg {
  stroke-width: 2 !important;
}

.\\[\\&\\>table\\>thead\\]\\:bg-gray-800>table>thead {
  background-color: var(--gray-800) !important;
}

.\\[\\&\\>ul\\]\\:list-inside>ul {
  list-style-position: inside !important;
}

.\\[\\&\\>ul\\]\\:list-disc>ul {
  list-style-type: disc !important;
}

.\\[\\&\\[data-headlessui-state\\=\\"open\\"\\]\\]\\:bg-gray-900[data-headlessui-state="open"] {
  background-color: var(--gray-900) !important;
}

.\\[\\&\\[data-headlessui-state\\=\\'open\\'\\]\\]\\:bg-gray-500[data-headlessui-state='open'] {
  background-color: var(--gray-500) !important;
}

.\\[\\&\\]\\:basis-\\[calc\\(33\\.3\\%-0\\.375rem\\)\\] {
  flex-basis: calc(33.3% - 0.375rem) !important;
}

.\\[\\&\\]\\:basis-\\[calc\\(50\\%-0\\.375rem\\)\\] {
  flex-basis: calc(50% - 0.375rem) !important;
}

.\\[\\&\\]\\:basis-\\[calc\\(66\\.6\\%-0\\.375rem\\)\\] {
  flex-basis: calc(66.6% - 0.375rem) !important;
}

.\\[\\&\\]\\:bg-gray-500 {
  background-color: var(--gray-500) !important;
}

.\\[\\&\\]\\:\\!pr-2 {
  padding-right: 8px !important;
}

.\\[\\&\\]\\:odd\\:bg-gray-600:nth-child(odd) {
  background-color: var(--gray-600) !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:h-\\[40px\\] .wallet-adapter-button {
  height: 40px !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:w-full .wallet-adapter-button {
  width: 100% !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:justify-center .wallet-adapter-button {
  justify-content: center !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:rounded-md .wallet-adapter-button {
  border-radius: 0.375rem !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:bg-white\\/10 .wallet-adapter-button {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.\\[\\&_\\.wallet-adapter-button\\]\\:bg-divvy-gradient .wallet-adapter-button {
  background-image: radial-gradient(circle at -62% 166%, #7c01ff, #00d77d 112%) !important;
}

.\\[\\&_\\.wallet-adapter-dropdown\\]\\:w-full .wallet-adapter-dropdown {
  width: 100% !important;
}

.\\[\\&\\~\\*\\]\\:-ml-1~* {
  margin-left: -4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,8BAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,mCAAc;UAAd;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;KAAd,sBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iFAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;EAAd;IAAA,uDAAc;IAAd,gCAAc;IAAd,6BAAc;IAAd,gBAAc;IAAd,eAAc;IAAd,mBAAc;EAAA;;EAAd,0CAAc;EAAd;;IAAA,wBAAc;IAAd,SAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,6BAAmB;EAAnB,qBAAmB;EAAnB,sBAAmB;EAAnB,qBAAmB;EAAnB,uBAAmB;EAAnB,2BAAmB;EAAnB,iCAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qBAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qBAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0LAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,gMAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+LAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB,0KAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB,0KAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,4BAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,4BAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,4BAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,6BAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;KAAnB,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,2CAAmB;EAAnB,mEAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,2CAAmB;EAAnB,mEAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,2CAAmB;EAAnB,mEAAmB;EAAnB,+CAAmB;EAAnB,uEAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,6FAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yFAAmB;EAAnB,yGAAmB;EAAnB,8HAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB,sEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,uEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,sEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,uEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB,uEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,wEAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,uEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB,wEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,wEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB,kEAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,+GAAmB;EAAnB,oIAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,+GAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,+GAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uLAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uLAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uLAAmB;EAAnB;AAAmB;AAAnB;EAAA,iHAAmB;EAAnB,2PAAmB;EAAnB;AAAmB;AAAnB;EAAA,kHAAmB;EAAnB,4PAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oNAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,4QAAmB;EAAnB,0RAAmB;EAAnB,oQAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,6QAAmB;EAAnB,0RAAmB;EAAnB,qQAAmB;EAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,sBAAmB;EAAnB,8CAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6JAAmB;UAAnB;AAAmB;AAAnB;EAAA,4HAAmB;UAAnB;AAAmB;AAgGjB;IACE,6DAAkD;EACpD;AACA;IACE,uDAA4C;EAC9C;AAiBA;IACE,qDAA0C;EAC5C;AAxHF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAanB;EACE,uBAAuB;EACvB,4CAAgD;EAChD;;;;;;yDAMoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,6CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,6CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AAmBA;EACE;IACE,4CAA4C;IAC5C,wDAAwD;EAC1D;EACA;IACE,2BAA2B;IAC3B,wDAAwD;EAC1D;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,uDAAuD;EACzD;EACA;IACE,uDAAuD;EACzD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,wDAAwD;EAC1D;AACF;;AA8BA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B;AACA;EACE,6BAAqB;EAArB,qBAAqB;AACvB;AACA;EACE;;sCAEkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AApKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,2BAqKA;EArKA,sBAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,2CAqKA;EArKA;AAqKA;;AArKA;EAAA,2CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,4CAqKA;EArKA;AAqKA;;AArKA;EAAA,4CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,kCAqKA;EArKA,0LAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,iCAqKA;EArKA,6CAqKA;EArKA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,mDAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,+BAqKA;EArKA,wCAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,0EAqKA;EArKA,uEAqKA;EArKA,6EAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,yCAqKA;EArKA,iDAqKA;EArKA,8EAqKA;EArKA;AAqKA;;AArKA;EAAA,yCAqKA;EArKA;AAqKA;;AArKA;EAAA,sHAqKA;EArKA,oHAqKA;EArKA,2FAqKA;EArKA;AAqKA;;AArKA;EAAA,yCAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA,6BAqKA;EArKA,kDAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,yCAqKA;EArKA,iDAqKA;EArKA,8EAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,iCAqKA;EArKA,6CAqKA;EArKA;AAqKA;;AArKA;EAAA,iCAqKA;EArKA,8CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,yCAqKA;EArKA,iDAqKA;EArKA,8EAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,qCAqKA;EArKA;AAqKA;;AArKA;EAAA,iCAqKA;EArKA,6CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,0BAqKA;IArKA,0BAqKA;IArKA,0KAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,6CAqKA;IArKA;EAqKA;;EArKA;IAAA,sCAqKA;IArKA;EAqKA;;EArKA;IAAA,2BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,0BAqKA;IArKA;EAqKA;;EArKA;IAAA,2BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,gCAqKA;IArKA,wLAqKA;IArKA;EAqKA;;EArKA;IAAA,0BAqKA;IArKA,0BAqKA;IArKA,0KAqKA;IArKA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA,4BAqKA;IArKA,8KAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,gCAqKA;SArKA;EAqKA;;EArKA;IAAA,kCAqKA;IArKA,uCAqKA;IArKA,+DAqKA;IArKA,4CAqKA;IArKA,oEAqKA;IArKA,gDAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,2CAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,0BAqKA;IArKA;EAqKA;;EArKA;IAAA,8BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA,mBAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,2BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,0BAqKA;IArKA;EAqKA;;EArKA;IAAA,kCAqKA;IArKA,0LAqKA;IArKA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,6BAqKA;IArKA;EAqKA;;EArKA;IAAA,4BAqKA;IArKA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;AAAA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,2CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,4CAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;EAAA;AAqKA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;;EAAA;IAAA;EAqKA;AAAA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,8BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,8BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,4BAqKA;EArKA;AAqKA;;AArKA;EAAA,4BAqKA;EArKA;AAqKA;;AArKA;EAAA,8BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,2BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,+BAqKA;EArKA,sCAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;;EAAA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA;EAqKA;;EArKA;IAAA,iCAqKA;IArKA,yLAqKA;IArKA;EAqKA;AAAA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,gCAqKA;EArKA,wLAqKA;EArKA;AAqKA;;AArKA;EAAA,gCAqKA;EArKA,wLAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,mCAqKA;EArKA,mEAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,2BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,0BAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA,iCAqKA;EArKA,yLAqKA;EArKA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA;;AArKA;EAAA;AAqKA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url(\"https://fonts.googleapis.com/css2?family=Satoshi:wght@300;400;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Anton:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap\");\n@import \"./styles/variables.css\";\n@import \"./styles/theme.css\";\n@import \"./styles/stars.css\";\n@import \"./styles/icons.css\";\n\n@font-face {\n  font-family: \"zb-icons\";\n  src: url(\"./assets/fonts/zb-icons.eot?38568115\");\n  src:\n    url(\"./assets/fonts/zb-icons.eot?38568115#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"./assets/fonts/zb-icons.woff2?38568115\") format(\"woff2\"),\n    url(\"./assets/fonts/zb-icons.woff?38568115\") format(\"woff\"),\n    url(\"./assets/fonts/zb-icons.ttf?38568115\") format(\"truetype\"),\n    url(\"./assets/fonts/zb-icons.svg?38568115#zb-icons\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Zeebit Sans\";\n  src: url(\"./assets/fonts/Zeebit-Sans.otf\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Zeebit Sans Caps\";\n  src: url(\"./assets/fonts/Zeebit-Sans-Caps.otf\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Zeebit Numeric\";\n  src: url(\"./assets/fonts/Zeebit-Sans-Test.otf\");\n  font-weight: normal;\n  font-style: normal;\n  padding-bottom: \"1em\";\n  padding-top: \"10%\";\n}\n\n@layer base {\n  html {\n    font-family: var(--default-app-font-family), sans-serif;\n    color: var(--general-text-color);\n    background: var(--general-bg);\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 1.1rem;\n  }\n\n  /* Hides up/down arrows in number inputs */\n  input[type=\"number\"]::-webkit-inner-spin-button,\n  input[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n@keyframes pinkPulse {\n  0% {\n    background: rgba(var(--brand-pink-rgb), 0.6);\n    box-shadow: 0px 0px 8px 0 rgba(var(--brand-pink-rgb), 1);\n  }\n  100% {\n    background: var(--gray-800);\n    box-shadow: 0px 0px 6px 0 rgba(var(--brand-pink-rgb), 0);\n  }\n}\n@keyframes shake {\n  0%,\n  100% {\n    transform: translate(0, 0);\n  }\n  20% {\n    transform: translate(calc(-3% * 0.4), calc(-3% * -0.2));\n  }\n  40% {\n    transform: translate(calc(-3% * 0.5), calc(-3% * -0.5));\n  }\n  60% {\n    transform: translate(calc(-3% * -0.3), calc(-3% * -0.3));\n  }\n  80% {\n    transform: translate(calc(-3% * -0.4), calc(-3% * -0.2));\n  }\n}\n\n@layer utilities {\n  .clip-unfold {\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n  }\n  .clip-fold {\n    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n  }\n  .clip-l-bar-unfold {\n    clip-path: polygon(\n      var(--side-bar-width) 0,\n      0 0,\n      0 100%,\n      var(--side-bar-width) 100%\n    );\n  }\n  .clip-l-bar-fold {\n    clip-path: polygon(\n      var(--side-bar-collapsed-width) 0,\n      0 0,\n      0 100%,\n      var(--side-bar-collapsed-width) 100%\n    );\n  }\n  .animate-pink-pulse {\n    animation: pinkPulse 1s alternate infinite;\n  }\n}\n\n.font-inter {\n  font-family: \"Inter\", sans-serif;\n}\n.font-raleway {\n  font-family: \"Raleway\", sans-serif;\n}\n.font-anton {\n  font-family: \"Anton\", sans-serif;\n}\n\n.font-Satoshi {\n  font-family: \"Satoshi\", \"sans-serif\";\n}\n\n.font-nunito {\n  font-family: \"Nunito\", \"sans-serif\";\n}\n\n.font-zeebit-sans {\n  font-family: \"Zeebit Sans\", sans-serif;\n}\n\np {\n  margin-bottom: 12px;\n}\na {\n  text-decoration: underline;\n}\na:hover {\n  text-decoration: none;\n}\n.bottom-nav-shadow {\n  box-shadow:\n    0 -15px 10px -5px rgb(0 0 0 / 0.2),\n    0 8px 10px -6px rgb(0 0 0 / 0.2);\n}\n\n.scroll-fix {\n  -webkit-overflow-scrolling: touch;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
